/*    
 *  _________________________________________
 * / Stop right there, ya dingus. This file  \
 * \ should not be edited.                   /
 *  -----------------------------------------
 *  \
 *   \
 *      __
 *     /  \
 *     |  |
 *     @  @
 *     |  |
 *     || |/
 *     || ||
 *     |\_/|
 *     \___/
 *    
 * This file is automatically generated through https://localise.biz.
 *                                                                         
 * To update this file:
 *
 *  $ npm run update-language
 *
 * Last update:    Tue Jul 07 2026 14:40:21 GMT+0200 (Central European Summer Time)
 * Language keys:  13
 * Language code:  de
 *
 */

const language = {
  "resources": {
    "alarms": {
      "name": "Alarm |||| Alarm",
      "create_title": "Alarm erstellen",
      "text": {
        "alarm_creator": "Alarmersteller",
        "alarm_creator_explanation": "Wählen Sie aus, wer oder was den Alarm auslöst. Die Position, Gruppen und Reaktionskonfiguration dieses Objekts oder dieser Person werden während des Alarmbearbeitungsprozesses verwendet.",
        "alarm_information": "Alarminformationen",
        "alarm_information_explanation": "Die folgenden Informationen werden verwendet, um zu bestimmen, was während des Alarms passieren soll. Wählen Sie einen kurzen Alarmnamen (z. B. „Panik-Alarm“) und wählen Sie die Alarmdringlichkeit aus.",
        "severity_options": {
          "red": "Rot (dringend)",
          "orange": "Orange (erfordert Aufmerksamkeit)",
          "green": "Grün (nicht dringend)"
        },
        "type_options": {
          "panic": "Panik",
          "assistance": "Hilfe",
          "test": "Prüfen",
          "outage": "Ausfall",
          "fire": "Feuer",
          "medical": "Medizinisch",
          "mandown": "Ein Mann weniger",
          "other": "Andere"
        },
        "procedure_placeholder": "Das Verfahren wird im X-Guard Alarm Manager und in der X-Guard Alarm App angezeigt.\n\nBeschreiben Sie, was Menschen tun müssen, die kommen, um zu helfen.",
        "ack_definition": "Erfordern eine Bestätigung",
        "ack_explanation": "Standardmäßig müssen Alarme quittiert werden. Mit unbestätigten Alarmen kann über den X-Guard Alarm Manager und die X-Guard Alarm App interagiert werden.",
        "ack": {
          "no_time": "Keine Zeit eingestellt",
          "open_alarm": "Offener Alarm",
          "not_needed": "Nicht benötigt",
          "acked": "Quittierter Alarm",
          "value": "Erfordert eine Bestätigung (empfohlen)"
        },
        "page_info": "Diese Seite zeigt einen schnellen Überblick über Alarme in Ihrer Organisation. Öffnen Sie den X-Guard Alarm Manager, um weitere Details zu einem Alarm zu erhalten.",
        "acknowledge_all": "Bestätigen Sie alle",
        "acknowledge_confirmation": "Sind Sie sicher, dass Sie %{length}-Alarme bestätigen möchten?",
        "acknowledge_selected": "Ausgewählte bestätigen",
        "acknowledge": "Anerkennen",
        "bhvk": {
          "create_title": "Machen Sie Alarm",
          "create_subtitle": "Machen Sie einen Demo-Alarm, indem Sie die pulsierende Taste links drücken. Wenn Sie darauf klicken, werden Sie entweder in der App oder per Telefonanruf benachrichtigt."
        },
        "how_to_receive_title": "Wie möchten Sie die Alarme erhalten?",
        "how_to_receive_subtitle": "Wenn die App heruntergeladen wird, verwendet das System die App zunächst, um Sie über neue Alarme zu informieren. Wenn Sie nur angerufen werden möchten, entfernen Sie die App.",
        "receive_options": {
          "call": "Einen Anruf bekommen",
          "app": "Über die App"
        },
        "app_explanation": {
          "1": "1. Installieren Sie die App",
          "2_title": "2. App-Anmeldung",
          "2_2": "Ihr Benutzername für die Anmeldung lautet:",
          "2_3": "Die App gibt Ihnen weitere Anweisungen.",
          "1_title": "3. Bereit, Alarme auszulösen",
          "3_2": "Drücken Sie die Taste, um einen Alarm auszulösen",
          "under_buttons": "Die App kann im App Store oder bei Google Play heruntergeladen werden"
        },
        "bhvk_alarm_created": "Alarm erstellt. Sie erhalten diesen Alarm über die ausgewählte Methode.",
        "simulation_result": "Folgende Personen werden benachrichtigt:",
        "no_alarms": "In den letzten 7 Tagen wurden keine Alarme ausgelöst.",
        "notified": "Benachrichtigt",
        "will_help": "Wird helfen",
        "will_not_help": "Wird nicht helfen",
        "nobody_notified": "Niemand, lesen Sie hier warum",
        "view_alarms": "Alarme anzeigen",
        "create_an_alarm": "Erstellen Sie einen Alarm",
        "title_subtext": "Auf dieser Seite finden Sie eine Übersicht aller Alarme.",
        "no_links": "Niemand",
        "no_one_called_for_link": "Zum jetzigen Zeitpunkt ist niemand für diesen Prozess vorgesehen."
      },
      "fields": {
        "name": "Alarmname",
        "severity": "Schwere",
        "type": "Alarmtyp",
        "procedure": "Verfahren",
        "ack": {
          "name": "Braucht Anerkennung",
          "value": "Anerkannt"
        },
        "alarmCenter": {
          "name": "Alarmzentrale"
        },
        "customer": {
          "_id": "Kunde"
        },
        "mergeHistory": "Dedupliziert"
      }
    },
    "assets": {
      "name": "Vermögenswert |||| Vermögenswerte",
      "text": {
        "annotation": "Auf dieser Seite werden keine App-Benutzer angezeigt",
        "without_app_title": "Vermögenswerte ohne App",
        "single_name": "Vermögenswert",
        "general": "Allgemein",
        "properties": "Eigenschaften",
        "response": "Antwort",
        "app": "App",
        "app_mode_not_editable": "Der App-Modus kann nicht bearbeitet werden",
        "app_available_explanation": "Wenn „Verfügbar“ aktiviert ist, kann der App-Benutzer Hilfeanfragen bei den Alarmen von Benutzern in der Nähe erhalten.",
        "download_history_button": "Verlauf herunterladen",
        "delete_user": "Benutzer löschen",
        "groups_updated": "Gruppen aktualisiert",
        "edit_groups": "Gruppen bearbeiten",
        "without_app_description": "Vermögenswerte sind Personen oder Objekte, die nicht an die X-Guard Alarm-App gebunden sind. Hier können Sie Assets ansehen und bearbeiten. Das Hinzufügen und Entfernen von Assets ist nicht möglich, da diese manchmal für erweiterte Konfigurationen in Ihrer Organisation verwendet werden. In den meisten Fällen möchten Sie anstelle eines Assets einen [Benutzer](%{adminPath}) oder einen [App-Benutzer](%{appUserPath}) erstellen.",
        "has_app": "Ist ein App-Konto",
        "add_bhv": "BHV'er hinzufügen",
        "add_user": "Benutzer hinzufügen",
        "add_user_tooltip": "Nach der Bestellung können Sie Benutzer hinzufügen",
        "add_bhv_tooltip": "Nach der Bestellung können Sie BHV'er hinzufügen",
        "bhvk_deleted": "Benutzer gelöscht",
        "number_of_available_users": "Gesamtzahl der Benutzer, die zum Empfangen von Alarmen verfügbar sind",
        "number_of_expiring_certifications": "Gesamtzahl der ablaufenden Zertifizierungen"
      },
      "fields": {
        "user": {
          "_id": "Benutzer"
        },
        "externalId": "Externe ID",
        "description": "Beschreibung",
        "phoneNumber": "Telefonnummer",
        "smsNumber": "SMS-Nummer",
        "email": "Email",
        "image": "Bild",
        "available": "Verfügbar",
        "staticResponders": {
          "name": "Statische Responder",
          "staticResponder": "Statischer Responder",
          "priority": "Priorität"
        },
        "position": {
          "provider": "Die Position ist statisch"
        },
        "invisibleResponder": "Ist ein unsichtbarer Responder",
        "allowContactOnOwnAlarms": "Kontakt bei eigenen Alarmen zulassen (Telefonnummer im Alarmmanager anzeigen)",
        "lastObservationAt": "Letzte Beobachtung bei",
        "insideZones": "Innenzonen",
        "can_receive": "Rufbereitschaft für andere",
        "my_security": "Meine Sicherheit",
        "last_active_at": "Zuletzt aktiv um",
        "has_app": "Nutzt die App"
      },
      "download_history_for_last": "Download-Verlauf zum letzten Mal:",
      "certifications": {
        "fields": {
          "documentary_proof": "Dokumentarischer Nachweis",
          "first_issued_on": "Erstveröffentlichung am",
          "last_received_on": "Erneuert am",
          "expiry_date": "Verfallsdatum",
          "planned_renewal_date": "Geplante Verlängerung"
        },
        "text": {
          "add_certification": "Zertifizierung hinzufügen",
          "sub_title": "Zertifizierungen",
          "not_provided": "Nicht angegeben",
          "not_required": "Nicht erforderlich",
          "not_required_description": "Für diese Zertifizierungskategorie ist kein Dokumentennachweis erforderlich.",
          "title_single": "Zertifizierung",
          "certification_deleted": "Zertifizierung gelöscht",
          "expiry_date_input_helper_text": "Das Ablaufdatum ist automatisch aus dem Datum des letzten Eingangs zuzüglich der Gültigkeitsdauer der Zertifizierungskategorie vorbelegt. Sie können es bei Bedarf manuell ändern.",
          "view_document": "Dokument anzeigen",
          "drop_document_to_upload": "Ziehen Sie das Dokument per Drag & Drop zum Hochladen oder klicken Sie darauf, um es auszuwählen.",
          "edit_certification_title": "%{category}-Zertifizierung für %{user_name} bearbeiten",
          "renew": "Verlängern",
          "renew_now_modal_title": "Jetzt verlängern",
          "renew_now_modal_helper_text": "Das Ablaufdatum wird anhand des zuletzt erhaltenen Datums plus der Gültigkeitsdauer der Zertifizierungskategorie vorausgefüllt. Sie können es bei Bedarf manuell ändern.",
          "plan_renewal_modal_title": "Verlängerung planen",
          "renew_bulk": "Zertifizierungen verlängern",
          "assign_document_to_user": "Benutzer zuweisen",
          "bulk_assign_documents_helper": "Weisen Sie jedes hochgeladene Dokument dem zugehörigen Benutzer zu.",
          "reset_document_assignments": "Zuweisungen zurücksetzen",
          "bulk_documents_count_mismatch": "Die Anzahl der hochgeladenen Dokumente muss mit der Anzahl der ausgewählten Benutzer übereinstimmen.",
          "bulk_documents_assignment_incomplete": "Weisen Sie jedes Dokument einem eindeutigen Benutzer zu. Jeder ausgewählte Benutzer muss genau ein Dokument erhalten.",
          "drop_documents_to_upload": "Ziehen Sie die Dokumente per Drag & Drop zum Hochladen oder klicken Sie, um sie auszuwählen",
          "bulk_upload_documents_helper": "Laden Sie %{smart_count} Dokumentennachweise für den ausgewählten Benutzer hoch.",
          "select_categories": "Zertifizierungskategorie auswählen",
          "preview_file": "Datei anzeigen",
          "select_user": "Benutzer auswählen",
          "select_category": "Kategorie auswählen",
          "planned_renewal_date_helper_text": "E-Mail-Benachrichtigungen werden bis zum geplanten Verlängerungsdatum pausiert."
        },
        "validation": {
          "expiry_date_must_be_future": "Das Ablaufdatum muss in der Zukunft liegen."
        }
      }
    },
    "app-users": {
      "text": {
        "sent_configuration": "Konfiguration an Gerät gesendet",
        "sent_configuration_failed": "Die Konfiguration konnte nicht an das Gerät gesendet werden",
        "sent_log": "Protokollanforderung an Gerät gesendet",
        "sent_log_failed": "Protokollanforderung konnte nicht an das Gerät gesendet werden",
        "actions": "Aktionen",
        "send_critical_title": "Als kritisch senden",
        "send_critical_explanation": "Dieser Schalter gibt an, ob die Benachrichtigung als kritisch gesendet werden soll. Stellen Sie den Schalter auf die gewünschte Position\n                bevor Sie auf die Schaltfläche klicken, um die Benachrichtigung zu senden.",
        "configuration_update_title": "Konfigurationsaktualisierung",
        "configuration_notification_title": "Konfigurationsbenachrichtigung senden",
        "configuration_notification_explanation": "Dadurch wird eine Benachrichtigung an das Gerät gesendet mit der Aufforderung, auf die Benachrichtigung zu klicken.\n                Wenn dies der Fall ist, wird ihre Konfiguration sofort neu geladen",
        "log_notification_title": "Geräteprotokoll anfordern",
        "log_notification_explanation": "Dadurch wird eine Benachrichtigung an das Gerät gesendet mit der Aufforderung, auf die Benachrichtigung zu klicken.\n                Wenn dies der Fall ist, lädt das Gerät ein Protokoll an das Entwicklungsteam hoch.",
        "device_info": "Geräteinformationen",
        "installed_version": "Installierte Version",
        "available_version": "Verfügbare Version",
        "compliance_state": "Compliance-Status",
        "compliance_true": "In Übereinstimmung",
        "compliance_false": "Nicht konform",
        "device_profile": "Geräteprofil",
        "permissions": "Berechtigungen (nur für das aktuelle Betriebssystem)",
        "saving_group_successful": "Gruppen erfolgreich gespeichert",
        "saving_group_failed": "Das Speichern der Gruppen ist fehlgeschlagen",
        "config": "Konfig",
        "group_title": "Gruppen",
        "group_explanation": "Wenn zwei Gruppen dieselben Konfigurationsschlüssel bearbeiten, überschreibt die letzte Gruppe die zuvor definierten Gruppen. Stellen Sie sicher, dass die Gruppenreihenfolge korrekt ist.",
        "last_sync": "Letzte Synchronisierung",
        "last_config_update": "Letztes Konfigurationsupdate",
        "last_config_compliance": "Letzte Konfigurationskonformität",
        "reset_groups": "Gruppen zurücksetzen",
        "save_groups": "Gruppen speichern",
        "no_valid_config": "Dieser Benutzer hat keine gültige Gerätekonfiguration und kann nicht bearbeitet werden",
        "download_group": "Gruppe? Lassen Sie das Feld leer, um keine Gruppe anzuhängen.",
        "view_device_json": "Konsole für Geräte-JSON anzeigen",
        "configuration": "Aufbau",
        "show_unmodified_keys": "Unveränderte Schlüssel anzeigen",
        "delete_success": "Gelöschte App-Benutzer",
        "delete_success_single": "Gelöschter App-Benutzer",
        "delete_failed": "Das Löschen der App-Benutzer ist fehlgeschlagen",
        "delete_failed_single": "Das Löschen des App-Benutzers ist fehlgeschlagen",
        "delete_title": "App-Benutzer löschen",
        "delete_all_devices": "Alle Geräte löschen",
        "updated": "App-Benutzer aktualisiert",
        "title": "App-Benutzer",
        "created": "App-Benutzer erstellt! Der Benutzer kann sich nun mit %{username} über die X-Guard Alarm-App anmelden",
        "create_explanation": "Um sich zu registrieren, öffnen Sie die X-Guard Alarm App und scannen Sie den QR-Code der Organisation",
        "page_info": "App-Benutzer haben die Möglichkeit, sich bei der X-Guard Alarm App anzumelden. App-Benutzer können sich nicht bei unseren Dashboards anmelden.\n\nEs ist derzeit nicht möglich, Benutzer zu ändern oder zu entfernen. Wenden Sie sich für Hilfe an den X-Guard-Support.\n\nUm einen neuen App-Benutzer hinzuzufügen, verwenden Sie bitte den QR-Code Ihrer Organisation, um mit unserer App fortzufahren.",
        "group_and_config_button_title": "Gruppen und Konfiguration",
        "config_and_groups_updated": "Gruppen und Konfiguration aktualisiert!",
        "fill_phonenumber": "Geben Sie zunächst eine Telefonnummer ein",
        "available_helper": "Wenn „Alarme empfangen“ aktiviert ist, empfängt dieses Konto aktiv geeignete Alarme. Dies geschieht entweder per Telefonanruf oder, wenn Sie eingeloggt sind, über die App.",
        "warning_sends_email": "Bitte beachten Sie: Dieses Registrierungsprofil sendet eine E-Mail an den neuen Benutzer",
        "create_continue": "Wie möchten Sie weitermachen?",
        "create_modal_intro": "App-Benutzer können auf zwei Arten registriert werden. Sie können den Benutzer dies selbst tun lassen, indem Sie beim Öffnen der App einen QR-Code scannen, oder Sie können den Benutzer selbst erstellen.",
        "create_modal_open_qrcodes": "Öffnen Sie QR-Codes",
        "create_modal_manually_create_user": "Benutzer manuell erstellen",
        "devlog_notification_title": "Fordern Sie das Geräteentwicklungsprotokoll an",
        "go_to_connected_users": "Zu den verbundenen Benutzern gehen",
        "ios_config_warning": "Diese Gruppe enthält Tasten, die unter iOS nicht funktionieren. Die nicht funktionierenden Tasten beziehen sich auf Zeitpläne. Alle anderen Tasten dieser Gruppe funktionieren weiterhin.",
        "include_button_count": "Anzahl der Flic-Tasten",
        "device_logs_title": "Geräteprotokolle",
        "device_logs_open_uploads": "Hochgeladene Geräteprotokolle anzeigen",
        "device_logs_open_uploads_explanation": "Wählen Sie ein oder mehrere hochgeladene Geräteprotokolle aus und laden Sie diese über die Report API.",
        "device_logs_uploads_modal_title": "Geräteprotokoll-Uploads",
        "device_logs_connected_device": "Verbundenes Gerät",
        "device_logs_upload_fetch_failed": "Fehler beim Laden der Geräteprotokolle.",
        "device_logs_no_connected_device": "Für diesen App-Nutzer wurde kein verbundenes Gerät gefunden.",
        "device_logs_uploads_empty": "Für dieses verbundene Gerät wurden keine Geräteprotokoll-Uploads gefunden.",
        "device_logs_upload_created_at": "Erstellt am",
        "device_logs_upload_start_date": "Startdatum",
        "device_logs_upload_end_date": "Enddatum",
        "device_logs_upload_count": "Anzahl der Protokolle",
        "device_logs_continue": "Weitermachen",
        "device_logs_result_modal_title": "Geräteprotokolle",
        "device_logs_group_label": "Hochladen",
        "device_logs_fetch_failed": "Die Protokolle des ausgewählten Geräts konnten nicht geladen werden.",
        "device_logs_fetch_group_failed": "Die Protokolle für diesen Upload konnten nicht geladen werden.",
        "device_logs_upload_severity_counts": "Schweregrad zählt",
        "device_logs_download": "Download-Protokolle",
        "device_logs_severity_filter": "Schwere",
        "device_logs_severity_filter_all": "Alle",
        "device_logs_show_ctx": "Kontext anzeigen"
      },
      "copy_device_json": "Geräte-JSON kopieren",
      "text_create_register_via_qr": "Der Benutzer muss sich über den QR-Code registrieren",
      "text_create_continue_to_create": "Ich werde den App-Benutzer manuell erstellen"
    },
    "asset-groups": {
      "fields": {
        "description": "Beschreibung",
        "asset_count": "Personenzahl",
        "assets": "Vermögenswerte",
        "bhvk_count": "Anzahl der Mitglieder",
        "bhvk_count_button": "%{length} Schaltflächen oder Personen anzeigen"
      },
      "text": {
        "title": "Asset-Gruppen",
        "title_single": "Gruppe",
        "page_info": "Gruppen werden von bestimmten Konfigurationen hinter den Kulissen verwendet, die sich auf die Alarmreaktion und -erstellung auswirken können.\n\nAuf dieser Seite können Sie überprüfen, ob Ihre Gruppen wie erwartet definiert sind.",
        "no_assets": "Keine Personen oder Objekte in dieser Gruppe",
        "create_title": "Neue Gruppe erstellen",
        "create_explanation": "Gruppen können zur Unterscheidung zwischen Benutzern verwendet werden. X-Guard ist in der Lage, verschiedene Konfigurationen für die App und Alarmreaktion einer Gruppe zuzuordnen.",
        "add_person": "Person hinzufügen",
        "delete_warning": "In dieser Gruppe wird konfiguriert, wie mit Alarmen umgegangen wird.",
        "delete_warning_multiple": "Eine oder mehrere der ausgewählten Gruppen werden verwendet, um zu konfigurieren, wie Alarme behandelt werden.",
        "delete_confirmation": "Mir ist bewusst, dass der Alarmvorgang durch Fortfahren möglicherweise unterbrochen wird. Ich werde diese Gruppe nicht entfernen, es sei denn, ich weiß sicher, dass das Alarmverfahren noch ordnungsgemäß funktioniert."
      },
      "name": "Gruppen"
    },
    "beacons": {
      "text": {
        "share_types": {
          "public": "Öffentlich",
          "default": "Standard"
        },
        "code": "Code",
        "title": "Leuchtfeuer",
        "low_battery": "Niedriger Batteriestatus",
        "beacon_last_seen": "Beacon wurde in den letzten 7 Tagen nicht gesehen",
        "beacon_healthy": "Leuchtfeuer gesund",
        "in_last_hour": "In der letzten Stunde"
      },
      "fields": {
        "codes": "Codes",
        "rssiAddend": "RSSI-Zusatz",
        "zone": {
          "_id": "Zone"
        },
        "state": {
          "lastSeenAt": "Zuletzt gesehen bei"
        },
        "share": {
          "type": "Freigabetyp"
        },
        "beacon_code": "Beacon-Code"
      }
    },
    "customer-links": {
      "fields": {
        "groups": "Gruppen",
        "alarmLevels": "Alarmstufen",
        "processTemplate": {
          "id": "Prozessvorlage"
        },
        "level": {
          "green": "Grün",
          "orange": "Orange",
          "red": "Rot",
          "mandown": "Ein Mann weniger"
        },
        "groupType": "Gruppentyp"
      },
      "text": {
        "title": "Kundenlinks",
        "group_types": {
          "all": "Alle Gruppen",
          "none": "Keine Gruppen",
          "some": "Einige Gruppen",
          "not_in": "Nicht in bestimmten Gruppen"
        },
        "types_placeholder": "Wenn keine Typen ausgewählt sind, ist die Kundenverknüpfung für alle Typen aktiv"
      }
    },
    "process-templates": {
      "text": {
        "no_asset_error": "Kein Asset ausgewählt",
        "simulation_error": "Fehler in der Simulation",
        "previous_stage_delay": "Verzögerung gegenüber der vorherigen Stufe: %{delay} Sekunden",
        "query_speed": "Abfragegeschwindigkeit",
        "alarmcenter_escalate": "Eskalieren",
        "alarmcenter_queue_name": "Name der Warteschlange",
        "no_results_in_stage": "In dieser Phase liegen keine Ergebnisse vor",
        "kilometers": "Kilometer",
        "asset_distance": "Distanz",
        "simulate_process": "ATS-Prozess simulieren",
        "simulate": "Simulieren",
        "simulation_started": "Simulation gestartet",
        "simulation_started_secondary": "ATS simuliert, bitte warten",
        "title": "Prozessvorlagen",
        "if_script": "Wenn Skript",
        "taskTemplate": {
          "id": "Aufgabenvorlage"
        },
        "schedule_tasks": "Planen Sie Aufgaben",
        "scope_customer": "Kundenspezifisch",
        "scope_global": "Global",
        "include_global_templates": "Globale Vorlagen einbeziehen",
        "global_badge": "Global",
        "add_step": "Schritt hinzufügen",
        "remove_step": "Schritt entfernen",
        "remove_step_confirm": "Möchten Sie diesen Schritt wirklich entfernen?",
        "duplicate_step": "Schritt duplizieren",
        "step_number": "Schritt %{number}",
        "always_execute": "Immer ausführen",
        "meta_script": "Eingabedaten",
        "xgac_filter": "Asset-Filter",
        "request_filters": "Anfragefilter",
        "clone": "Klonen",
        "contacted_not_before": "Noch nicht kontaktiert",
        "asset_id_not_own": "Nicht eigene Asset-ID",
        "asset_id_own": "Eigene Asset-ID",
        "custom_filter_key": "Filter-Schlüssel auswählen oder eingeben",
        "filters": "Filter",
        "add_filter": "Filter hinzufügen",
        "invalid_filter_key": "Dieser Filter-Schlüssel wird von ATS getAssets nicht unterstützt",
        "invalid_filter_value": "Ungültiger Filterwert",
        "max_results": "Max. Ergebnisse (0 für unbegrenzt)",
        "max_unlimited": "Unbegrenzt",
        "max_distance_warning": "Warnung: Wählen Sie bei Verwendung des Entfernungsfilters nicht mehr als 10 Elemente aus. Überprüfen Sie das Simulationsergebnis, bevor Sie fortfahren.",
        "filter_available_yes": "Verfügbar",
        "filter_available_no": "Nicht verfügbar",
        "comparator_equals": "equals",
        "comparator_not_equals": "nicht gleich",
        "comparator_less_than": "kleiner als",
        "comparator_less_than_or_equal": "kleiner oder gleich",
        "comparator_greater_than": "größer als",
        "comparator_greater_than_or_equal": "größer oder gleich",
        "same_as_previous_step": "Gleich wie vorheriger Schritt",
        "step_not_configured": "Nicht konfiguriert",
        "schedule_tasks_required": "Mindestens eine geplante Aufgabe ist erforderlich",
        "meta_data": "Metadaten",
        "meta_data_variables": "Variablen: %{variables}",
        "meta_data_example": "Beispiel",
        "any_own_groups": "Beliebige eigene Gruppen"
      },
      "fields": {
        "processName": "Prozessname",
        "description": "Beschreibung",
        "delay": "Verzögerung",
        "filter_value": "Wert",
        "filter_key": "Filter",
        "required_confirmations": "Erforderliche Bestätigungen",
        "filter_comparator": "Vergleich",
        "filter_value_seconds": "Sekunden"
      }
    },
    "users": {
      "fields": {
        "username": "Nutzername",
        "group_restrictions": "Einschränkungen für Asset-Gruppen",
        "roles": "Rollen",
        "lastActiveAt": "Zuletzt aktiv um",
        "map_viewer": "Hat Zugriff auf die Live-Karte",
        "userPolicies": {
          "disablePasswordlessLogin": "Deaktivieren Sie die passwortlose Anmeldung"
        },
        "accessRequest": {
          "validUntil": "Hat Zugriff bis (Leer lassen, wenn der Zugriff ohne Enddatum sein soll)"
        },
        "certification_categories": "Zertifizierungskategorien"
      },
      "text": {
        "password_reset_sent": "Anfrage zum Zurücksetzen des Passworts gesendet",
        "password_reset_failed": "Die Anforderung zum Zurücksetzen des Passworts ist fehlgeschlagen",
        "password_reset_button": "Senden Sie eine E-Mail zum Zurücksetzen des Passworts",
        "password_reset_button_description": "Sind Sie sicher, dass Sie das Passwort dieses Benutzers zurücksetzen möchten? Bei der ersten Anmeldung müssen sie ein neues Passwort festlegen",
        "password_reset_mail_confirm": "E-Mail senden",
        "roles": {
          "app_user": "App-Benutzer – nicht festlegen",
          "map_viewer": "Kartenbetrachter",
          "centralist": "Zentralistisch",
          "customer_admin": "Kundenadministrator",
          "viewer": "Zuschauer",
          "alarm_responder": "Alarmhelfer",
          "ats_responder": "ATS-Responder",
          "kioskUser": "Benutzer anzeigen",
          "customer_admin_external_id": "Kann externe ID hinzufügen oder bearbeiten",
          "customer_admin_special_username": "Kann Benutzer mit einem Benutzernamen erstellen, der nicht auf der E-Mail-Adresse basiert",
          "flic_hub_tester": "Flic-Hub-Tester",
          "customer_admin_app_user_history": "Kann den Verlauf der App-Benutzer herunterladen",
          "fingerprinter": "Fingerabdruck",
          "bhvk_trial": "BHV-Knop Testnutzer",
          "bhvk_admin": "BHV-Knop-Administratorbenutzer",
          "apr_visible": "Kann die Alarm Professional Response (Sequrix) starten",
          "sales_admin": "Vertriebsverwaltung",
          "support_admin": "Support-Administrator"
        },
        "roles_title": "Rollen",
        "invalid_phone": "Muss eine gültige Telefonnummer sein, beginnend mit +",
        "invalid_sms": "Muss eine gültige SMS-Nummer sein, beginnend mit +",
        "title": "Benutzer",
        "customer_user_relations": "Kunden-Benutzerbeziehungen",
        "update_success": "Benutzer aktualisiert",
        "admins_title": "Admins",
        "username_already_exists": "Der Benutzername ist bereits vorhanden. Wählen Sie einen anderen aus, um fortzufahren",
        "page_info": "Auf dieser Seite werden Benutzer angezeigt, die sich beim X-Guard Alarm Manager und/oder beim X-Guard Management Dashboard anmelden können.",
        "access_to_dashboard": "Zugriff auf das Dashboard",
        "receives_alarms": "Empfängt Alarme",
        "saving_successful": "Benutzer gespeichert!",
        "sub_title": "Auf dieser Seite werden alle Benutzer Ihrer BHV-Knop-Organisationen angezeigt. Es gibt Einstellungen pro Benutzer.",
        "available": "Empfängt Alarme",
        "create_success": "Benutzer erstellt",
        "has_access_to_dashboard": "Hat Zugriff auf das Management-Dashboard",
        "has_access_to_am": "Hat Zugriff auf den Alarmmanager",
        "add": "Benutzer hinzufügen",
        "manually": "Manuell",
        "username_should_be_email": "Benutzernamen sollten auf der E-Mail-Adresse des Benutzers basieren. Andernfalls wird die Anmeldung für diesen Benutzer schwieriger.",
        "delete_users": "Benutzer löschen",
        "delete_users_warning": "Möchten Sie wirklich %{smart_count} Benutzer löschen?",
        "users_with": {
          "multiple_connections": "Achtung! Ein Benutzer ist mit mehreren Kunden verbunden. Sehen Sie sie sich unten an. |||| Achtung! Ein Benutzer ist mit mehreren Kunden verbunden. Sehen Sie sie sich unten an."
        },
        "2fa_title": "Zwei-Faktor-Authentifizierung aktivieren",
        "2fa_enable_description": "Mit aktivierter Zwei-Faktor-Authentifizierung ist Ihr Konto sicherer. Sobald diese Option aktiviert ist, werden Sie bei jeder Anmeldung mit diesem Konto im Management Dashboard in der Authenticator-App Ihrer Wahl nach dem Code gefragt. Scannen Sie dazu den unten stehenden Code mit Ihrer Authenticator-App, z. B. Google Authenticator.",
        "2fa_code": "Code",
        "2fa_enable": "Aktivieren",
        "2fa_enabled": "Zwei-Faktor-Authentifizierung aktiviert",
        "2fa_enable_failed": "Aktivieren der Zwei-Faktor-Authentifizierung fehlgeschlagen",
        "2fa_already_enabled": "Die Zwei-Faktor-Authentifizierung ist für Ihr Konto bereits aktiviert. Um sie zu deaktivieren, geben Sie unten Ihren Zwei-Faktor-Authentifizierungscode ein. Die bei der Einrichtung der Zwei-Faktor-Authentifizierung generierten Wiederherstellungscodes können auch zum Deaktivieren der Zwei-Faktor-Authentifizierung verwendet werden.",
        "2fa_disabled": "Zwei-Faktor-Authentifizierung erfolgreich deaktiviert",
        "2fa_disable_failed": "Das Deaktivieren der Zwei-Faktor-Authentifizierung ist fehlgeschlagen",
        "2fa_disable": "Deaktivieren",
        "2fa_recovery_codes": "Wiederherstellungscodes:",
        "2fa_recovery_codes_copied": "Wiederherstellungscodes in die Zwischenablage kopiert",
        "customer_passwordless_disabled_tooltip": "Passwortlose Anmeldung für Kunden deaktiviert"
      }
    },
    "customers": {
      "text": {
        "title": "Kunden",
        "alarmcenter_queueName": "Warteschlange in der Alarmzentrale (fragen Sie Jesse oder Luuk)",
        "alarmcenter_title": "Alarmzentralen",
        "update_success": "Kunde aktualisiert",
        "uuid_validation": "Muss eine gültige UUID sein",
        "title_single": "Kunde",
        "create_success": "Vom Kunden erstellt!"
      },
      "fields": {
        "locale": "Gebietsschema",
        "responsePartner": "Ist Antwortpartner",
        "responsePartners": "Reaktionspartner",
        "responsePartner_name": "Reaktionspartner",
        "alarmCenter_name": "Alarmzentrale",
        "alarmcenter_relation": {
          "enabled": "Ermöglicht"
        },
        "mergeConfig": {
          "enabled": "Alarmzusammenführung aktivieren",
          "maxTimeBetweenAlarmsMs": "Maximale Zeit zwischen Alarmen (Sekunden)",
          "retriggerAtsAfterMs": "ATS nach Zeit (Sekunden) erneut auslösen",
          "onlyMergeWhenSame": "Nur zusammenführen, wenn eines (oder mehrere) dieser Felder gleich sind",
          "use_default": "Verwenden Sie die Standard-Merge-Konfiguration"
        },
        "alarmAgeLimit": "Alarme sichtbar für",
        "hasAlarmAgeLimit": "Das Alter der sichtbaren Alarme ist begrenzt",
        "kiosk_config": {
          "what_groups": "Welche Vermögensgruppen möchten Sie anzeigen?",
          "what_labels": "Welche Labels möchten Sie zeigen?",
          "which_functions": "Welche Funktionen möchten Sie aktivieren?",
          "show_alarms": "Alarme anzeigen",
          "manage_availability": "Verfügbarkeit verwalten",
          "screen_schedule": "Bildschirmplan",
          "incident_counter": "Vorfallzähler",
          "front_page": "Titelseite",
          "anonymise_data": "Daten anonymisieren",
          "incident_counter_count_from_date": "Zählen ab Datum",
          "incident_counter_threshold": "Schwellenwert (Zähler im Falle eines aktuellen Vorfalls ausblenden)",
          "incident_counter_threshold_helper_text": "Wenn kein Datum festgelegt ist, werden die Tage seit dem letzten Vorfall gezählt.",
          "manage_availability_pin": "Geheimzahl",
          "manage_availability_app_hint": "Hinweis anzeigen: App installieren",
          "manage_availability_show_search": "Sucheingabe immer anzeigen",
          "manage_availability_show_label_filter": "Etikettenfilter immer anzeigen",
          "alarm_audio": "Machen Sie Lärm durch Alarm",
          "alarm_flash": "Flash-Bildschirm bei Alarm",
          "alarm_show_position_labels": "Alarmposition auf der Karte anzeigen",
          "alarm_anonymous": "Daten anonymisieren",
          "alarm_mode": "Alarmmodus",
          "alarm_acknowledge": "Alarm bestätigen",
          "alarm_acknowledge_pin": "Code zum Quittieren von Alarmen",
          "asset_inside_zones": "Nur Assets innerhalb von Zonen anzeigen",
          "hardware": "Hardware",
          "screen_brightness": "Bildschirmhelligkeit",
          "countAssets": "Im Zähler einzubeziehende Asset-Gruppen",
          "flash": "Blitz und Ton",
          "logo": "Sichtbares Logo",
          "schedule_entries": "Wann soll der Bildschirm eingeschaltet werden?",
          "anonymise_data_description": "Möchten Sie auf der Homepage Ihres Kiosks vollständige Namen (und optional Fotos) anzeigen? In der anonymen Version des Kiosks werden nur die Zähler angezeigt.",
          "what_groups_description": "Ihre Organisation umfasst möglicherweise verschiedene Personengruppen. Wählen Sie die relevanten Gruppen aus, die auf diesem Kiosk angezeigt werden sollen.",
          "logo_description": "Wenn Sie kein Logo hochladen, ist das Standardlogo von X-Guard oder BHV-Knop.nl auf dem Kiosk sichtbar.",
          "manage_availability_description": "Möchten Sie diesen Kiosk zur Verwaltung der Verfügbarkeit verwenden? Diese Funktion ist nur bei Kiosken mit angeschlossenem Touchscreen oder Maus nützlich.",
          "manage_availability_pin_description": "Sie können die Bearbeitungsverfügbarkeit optional mit einer PIN schützen. Lassen Sie das Feld leer, wenn keine PIN erforderlich ist.",
          "show_alarms_description": "Möchten Sie aktive Alarme am Kiosk anzeigen? Dies kann Ihrem Personal dabei helfen, den Ort des Alarms zu lokalisieren und so schnell wie möglich dorthin zu gelangen.",
          "alarm_anonymous_description": "Im Alarmfall zeigen wir an, wer gerufen wird und wer sich bereit erklärt hat, auf den Alarm zu reagieren. Diese Daten können auf Wunsch anonymisiert werden.",
          "flash_description": "Bei einem Alarm erklingt ein lauter Ton und ein Blinken. Bitte beachten Sie, dass die Alarmtonfunktion nur bei vorprogrammierten Kiosken von BHV-Knop.nl zuverlässig verfügbar ist.",
          "alarm_acknowledge_description": "Mithilfe dieser Funktion können Sie diesen Kiosk nutzen, um schnell zusammenzufassen, was passiert ist, und den Alarm zu bestätigen.",
          "alarm_acknowledge_pin_description": "Möchten Sie die Alarmquittierung mit einer PIN schützen?",
          "incident_counter_description": "Um eine sichere Arbeitsumgebung zu fördern, können Sie auf der Homepage Ihres Kiosks einen Vorfallzähler anzeigen.",
          "incident_counter_count_from_date_description": "Ab welchem Datum soll der Vorfallzähler zählen? Zur Auswahl stehen das Datum des letzten Alarms oder ein festes Datum, das Sie selbst festlegen.",
          "screen_schedule_description": "Um den Kiosk-Bildschirm zu schützen, können Sie den Bildschirmzeitplan aktivieren. Außerhalb des definierten Zeitplans wird der Bildschirm ausgeschaltet.",
          "schedule_entries_description": "Außerhalb dieser Zeiten ist der Bildschirm schwarz. Durch Berühren des Bildschirms wird der Kiosk aktiviert, auch außerhalb der Zeiten.",
          "manage_availability_pin_error": "Der PIN muss zwischen 4 und 6 Zeichen lang sein.",
          "sound_description": "Bei einem Alarm ertönt ein lauter Ton. Bitte beachten Sie, dass die Alarmtonfunktion nur bei vorprogrammierten Kiosken von BHV-Knop.nl zuverlässig verfügbar ist.",
          "sound": "Klang",
          "alarm_sound": "Wählen Sie Ihren Sound",
          "alarm_sound_description": "Welchen Ton Sie während einer Alarmsituation abspielen möchten, bleibt ganz Ihnen überlassen. Sie können sich entweder für etwas entscheiden, das einem Feueralarm ähnelt, oder für etwas sehr Sanftes.",
          "alarm_sound_volume": "Lautstärke",
          "alarm_sound_volume_description": "Wir empfehlen eine Lautstärke von 100 %. Wenn Ihnen das jedoch zu laut ist, können Sie es hier anpassen.",
          "alarm_sound_stop_after_touch": "Ton bei Berührung stoppen",
          "alarm_sound_stop_after_touch_description": "Wenn Sie den Bildschirm berühren, stoppt der Kiosk die Wiedergabe des Alarmtons.",
          "alarm_sound_stop_after_seconds": "Ton stoppen nach...",
          "alarm_sound_stop_after_seconds_description": "Nach wie vielen Sekunden soll der Alarmton verstummen? Sie können auch wählen, ob er wiederholt werden soll, bis der Alarm bestätigt wurde.",
          "count_label_separately": "Zähler pro Gruppe",
          "count_label_separately_description": "Es ist möglich, pro ausgewählter Gruppe zu zählen, anstatt die Gesamtzahl anzuzeigen.",
          "alarm_mode_description": "Der Alarmmodus bestimmt, ob Alarme nur für die Zone angezeigt werden, in der sich der Kiosk befindet, oder für alle Alarme in diesem Konto.",
          "alarm_modes": {
            "zoneBased": "Alarme in der Zone anzeigen",
            "customerBased": "Alarme im Kundenbereich anzeigen"
          }
        },
        "disableAutomaticGenerationOfButtonZones": "Automatische Generierung von Schaltflächenzonen deaktivieren",
        "alarmCenter": {
          "phoneNumber": "Rückrufnummer der Alarmzentrale"
        },
        "userPolicies": {
          "disablePasswordlessLogin": "Deaktivieren Sie die passwortlose Anmeldung für Benutzer"
        },
        "securityInventoryEnabled": "Sicherheitsinventar aktiviert",
        "recurringTasksEnabled": "Wiederkehrende Aufgaben aktiviert",
        "enableZoneEnterExitEvents": "Zonen-Ein-/Austrittsereignisse aktivieren"
      }
    },
    "tags": {
      "text": {
        "title": "Etikett"
      }
    },
    "devices": {
      "text": {
        "title": "Geräte",
        "types": {
          "lora": "Lora",
          "appDevice": "appDevice",
          "flic": "Flic",
          "generic": "Generisch",
          "loraGateway": "Lora-Tor"
        },
        "no_lora_config": "Keine spezifische Lora-Konfiguration",
        "error_getting_devices": "Fehler beim Abrufen der Geräte",
        "result": "Ergebnis",
        "downLink_explanation": "Senden Sie eine Hex-Nutzlast für IoTracker-Geräte, die mit dem KPN-Netzwerk verbunden sind",
        "buttons": "Tasten"
      },
      "fields": {
        "deviceId": "Geräte ID",
        "type": "Typ",
        "loraConfig": {
          "type": "Lora-Gerätetyp",
          "fieldtest": "Feldtest-Beobachtungscode",
          "beaconScan": "Beacon-Beobachtungscode",
          "gps": "GPS-Beobachtungscode",
          "preMandown": "Beobachtungscode vor ManDown",
          "mandown": "ManDown-Beobachtungscode",
          "alarmSeverity": "Alarmbeobachtungscode",
          "alive": "Leerer Beobachtungscode",
          "floodDetected": "Beobachtungscode für Überschwemmung erkannt",
          "noFloodDetected": "Kein Beobachtungscode für Überschwemmung erkannt",
          "type_help": "Stellen Sie sicher, dass der richtige Gerätetyp ausgewählt ist. Wenn der Gerätetyp falsch ist, wird die bearbeitete Konfiguration nicht verwendet.",
          "movement": "Bewegungsbeobachtungscode"
        },
        "battery": "Batterie"
      },
      "actions": {
        "downLink": "Downlink"
      }
    },
    "flic-buttons": {
      "text": {
        "invalid_hub_id": "Ungültige Hub-ID",
        "title": "Flic-Tasten",
        "found_button": "Button gefunden!",
        "config": {
          "title": "Verwenden Sie die folgende Konfiguration für die Schaltfläche:",
          "single_click_title": "Einzelklick-Ereignis",
          "single_click_description": "Metainformationen der Schaltfläche „Aktualisieren“.",
          "double_click_title": "Doppelklick-Ereignis",
          "double_click_description": "Bestätigen (schließen) Sie den zuletzt von derselben Anlage ausgelösten Alarm",
          "hold_title": "Veranstaltung durchführen",
          "hold_description": "Erstellen Sie einen Alarm gemäß der obigen Konfiguration",
          "hub_action": "Hub-Aktion",
          "internet_request": "Internetanfrage",
          "url": "URL",
          "method": "Methode",
          "method_post": "POST",
          "description": "Beschreibung"
        },
        "waiting_for_press": "Warten auf Tastendruck",
        "test_mode_active_until": "Testmodus aktiv bis",
        "activate_test_mode": "Testmodus aktivieren",
        "test_mode": "Testmodus"
      },
      "fields": {
        "action": "Aktion",
        "serial": "Seriell",
        "battery": "Batterie",
        "deleted": "Gelöscht"
      }
    },
    "flic-hubs": {
      "text": {
        "title": "Flic-Naben"
      },
      "fields": {
        "alarmLevel": "Alarmstufe",
        "xgacCustomerId": "Kunde"
      },
      "go_to_buttons": "Tasten"
    },
    "observation-triggers": {
      "text": {
        "title": "Beobachtungsauslöser",
        "general": "Allgemein",
        "action_config": "Aktionskonfiguration",
        "add_action": "Aktion hinzufügen",
        "add_eventcode": "Ereigniscode hinzufügen",
        "filter": "Filter"
      },
      "fields": {
        "eventCodes": "Ereigniscodes",
        "description": "Beschreibung",
        "active_status": "Aktiver Status",
        "type": "Typ",
        "config": {
          "\u0000": "Aufbau",
          "available_false": "Nicht verfugbar",
          "toContactList": "Kontaktlisten",
          "toRaw": "Empfanger",
          "available_true": "Verfugbar",
          "customer_default": "Kundenstandard",
          "toTriggerUser": "Auslosender Benutzer",
          "do_not_change": "Nicht andern"
        },
        "filter_type": "Filtertyp",
        "action_type": "Aktionstyp",
        "schedule_entries": "Zeitplaneintrage",
        "days": "Tage",
        "operands": "Bedingungen",
        "operand": "Bedingung",
        "timeStart": "Startzeit",
        "timeEnd": "Endzeit",
        "match": "Ubereinstimmung",
        "condition_block": "Bedingungsblock"
      },
      "action_types": {
        "alarm": "Alarm",
        "sms": "SMS",
        "email": "E-Mail",
        "assetUpdate": "Asset aktualisieren"
      },
      "filter_types": {
        "operator_or": "Eine der Bedingungen",
        "constraint_assetGroup": "Asset-Gruppe",
        "operator_and": "Alle Bedingungen",
        "constraint_asset": "Asset",
        "constraint_zone": "Zone",
        "operator_not": "Nicht",
        "constraint_schedule": "Zeitplan",
        "operator_none": "Keine Bedingungen"
      },
      "validation": {
        "time": "Geben Sie eine gultige Uhrzeit ein (HH:mm)"
      },
      "match_types": {
        "matches": "Stimmt uberein",
        "does_not_match": "Stimmt nicht uberein"
      }
    },
    "overlays": {
      "text": {
        "title": "Überlagerungen",
        "overlay_not_found": "Overlay nicht gefunden oder nicht bearbeitet",
        "create": "Neues Overlay hinzufügen",
        "delete_dialog_title": "Overlay löschen",
        "delete_dialog_content": "Möchten Sie dieses Overlay wirklich löschen?",
        "add_marker": "Fügen Sie eine Markierung hinzu, indem Sie auf den gewünschten Ort auf der Karte klicken, um mit der Erstellung fortzufahren",
        "place_marker": "Platzieren Sie die Markierung in der Mitte der Überlagerung"
      },
      "fields": {
        "image": "Bild",
        "image_url": "Bild URL",
        "points": "Punkte"
      },
      "notifications": {
        "overlay_too_small": "Overlay zu klein. Bitte bearbeiten, um es zu vergrößern."
      }
    },
    "qr-templates": {
      "text": {
        "title": "QR-Code-Vorlagen",
        "mail_recipient_types": {
          "asset": "Vermögenswert",
          "manual": "Handbuch"
        },
        "generating_qr": "QR wird generiert, bitte warten...",
        "code_created": "Code erstellt",
        "code_created_failed": "Code nicht erstellt",
        "code_updated": "Code aktualisiert",
        "code_updated_ failed": "Code nicht aktualisiert",
        "code_deleted": "Code gelöscht",
        "code_deleted_failed": "Code nicht gelöscht",
        "options": "Optionen",
        "default_qr": "Standard-QR",
        "brochure_nl": "Broschüre NL",
        "brochure_en": "Broschüre EN",
        "field": "Feld",
        "value": "Sjabloon-Etikett",
        "locked": "Gesperrt",
        "external_id": "Externe ID",
        "first_name": "Vorname",
        "last_name": "Familienname, Nachname",
        "user_email": "Benutzer Email",
        "phone_prefix": "Vorwahl des Telefonlandes",
        "phone_number": "Telefonnummer",
        "available": "Verfügbar",
        "limit": "Grenze",
        "save_first": "Speichern Sie zuerst, bevor Sie Codes hinzufügen",
        "codes": "Codes",
        "actions_save_first": "Um Aktionen hinzuzufügen, speichern Sie zunächst",
        "registering_title": "Registrieren... Bitte warten",
        "uploading": "Datei wird hochgeladen, bitte warten...",
        "download_qr": "Laden Sie QR herunter oder zeigen Sie es in der Vorschau an",
        "preview": "Sicht",
        "single_title": "QR-Vorlage",
        "sends_email": "Sendet E-Mail",
        "paused": "Angehalten",
        "pause_throttle": "Anti-Spam pausieren",
        "pause_throttle_explanation": "Wenn Sie sich mit einer Gruppe anmelden, klicken Sie auf die Schaltfläche unten. Die Gruppenanmeldung ist für 1 Stunde möglich.",
        "end_pause_throttle": "Sicherheit jetzt wieder aktivieren"
      },
      "fields": {
        "group_list": "Gruppenliste",
        "recipient_type": "Empfängertyp",
        "template_label": "Vorlagenetikett",
        "template_value": "Vorlagenwert",
        "recipient_list": "Empfängerliste",
        "template_updated": "Vorlage aktualisiert",
        "template_update_failed": "Vorlage nicht aktualisiert",
        "pages": "Seiten",
        "visible": "Sichtbar",
        "actions": "Aktionen"
      }
    },
    "service-accounts": {
      "text": {
        "title": "Dienstkonten",
        "username_validation": "Der Benutzername des Dienstkontos muss mit „sa-“ beginnen."
      }
    },
    "static-responders": {
      "text": {
        "title": "Statische Responder",
        "days": {
          "monday": "Montag",
          "tuesday": "Dienstag",
          "wednesday": "Mittwoch",
          "thursday": "Donnerstag",
          "friday": "Freitag",
          "saturday": "Samstag",
          "sunday": "Sonntag",
          "all": "Alle Tage",
          "weekdays": "Arbeitstage",
          "weekends": "Wochenende"
        },
        "general": "Allgemein",
        "contact_options": "Kontaktmöglichkeiten",
        "availability": "Verfügbarkeit",
        "professional_response": "Professionelle Antwort",
        "postcodes": "Postleitzahlen"
      },
      "fields": {
        "schedule_entry_add": "Zeitplaneintrag hinzufügen",
        "contact": {
          "camera": "Kamera"
        },
        "externalId": " Externe ID",
        "schedule": {
          "name": "Zeitplan",
          "entries": "Einträge planen"
        },
        "days_of_week": "Wochentage",
        "time_start": "Mal starten",
        "time_end": "Ende der Zeit",
        "integrations": {
          "sequrix": {
            "enabled": "Sequrix",
            "objectCode": "Objektcode"
          }
        }
      },
      "notifications": {
        "postcodes_updated": "Statische Antwortgeber in Zone %{smart_count} aktualisiert |||| Statische Antwortgeber in Zone %{smart_count} aktualisiert",
        "no_changes": "Keine Änderungen bei den Antwortenden festgestellt",
        "invalid_postcode": "Postleitzahl ungültig, bitte versuchen Sie es erneut"
      }
    },
    "webhooks": {
      "text": {
        "title": "Webhooks",
        "entity": "Juristische Person",
        "filter_explanation": "Webhook-Filter (Mongo-Abfrageformat)",
        "delivery": "Lieferung",
        "enabling": "Aktivieren",
        "output_preview": "Ausgabevorschau"
      },
      "fields": {
        "enableWebhook": "Webhook aktiviert",
        "webhookQuery": {
          "operation": "Betrieb",
          "entityTypes": "Entitätstypen",
          "filter": "Filter"
        },
        "deliveryConfig": {
          "method": "Methode",
          "url": "URL",
          "headers": "Überschriften"
        },
        "deliveryStats": {
          "numDeliverySucceeded": "Anzahl erfolgreicher Lieferungen",
          "numDeliveryFailed": "Anzahl fehlgeschlagener Lieferungen",
          "lastDeliveryDate": "Letzte erfolgreiche Lieferung"
        }
      }
    },
    "zones": {
      "text": {
        "zoneTypes": {
          "default": "Standard",
          "response_area": "Antwortbereich",
          "police_department": "Polizeirevier",
          "fingerprinted": "Fingerabdrücke",
          "assetMonitoredArea": "Überwachter Anlagenbereich",
          "building": "Gebäude",
          "evacuationPoint": "Evakuierungspunkt"
        },
        "title": "Zonen",
        "polygon_should_smaller": "Die Polygonfläche sollte kleiner als eine einzelne Halbkugel sein",
        "one_figure_per_zone": "Sie können pro Zone nur eine Figur hinzufügen.",
        "invalid_zone": "Zone ist ungültig: Mehr oder weniger als eine Zahl.",
        "title_single": "Zone",
        "invalid_zone_intersection": "Zone ist ungültig: Hat Selbstüberschneidung.",
        "syncToAms_explanation": "Wenn diese Zone aktiviert ist, wird sie als AMS-Zone verwendet, sodass Geräte beim Betreten/Verlassen der Zone unterschiedliche Aktionen auslösen können.\nDerzeit nur relevant für den Wechsel der BHV-Knop.nl-Verfügbarkeit. Dies wird später erweitert.",
        "beacons_in_zone": "Leuchtfeuer in dieser Zone",
        "assets_inside": "Derzeit befinden sich %{length} Personen in dieser Zone",
        "updated": "Zone aktualisiert!",
        "assets_inside_dialog_title": "Personen innerhalb dieser Zone",
        "zone_list": "Zonenliste",
        "manage": "Zonen verwalten",
        "created": "Zone erstellt!",
        "delete": "Zone löschen",
        "deleted": "Zone gelöscht",
        "create_mode_dialog_title": "Möchten Sie diese Zone als Punkt auf der Karte oder als Fläche erstellen?",
        "area": "Bereich",
        "area_subtext": "Zeichnen Sie einen geschlossenen Bereich auf der Karte ein",
        "marker": "Punkt auf der Karte",
        "marker_subtext": "Ein Punkt auf der Karte.\nGeeignet für die Lokalisierung mit X-Guard Beacons",
        "edit_warning": "Sie bearbeiten gerade eine Zone. Speichern Sie diese Änderungen oder brechen Sie den Vorgang ab.",
        "still_editing_warning": "Sie bearbeiten derzeit eine Zone. Speichern Sie dies oder verwerfen Sie die Änderungen.",
        "assets_inside_empty": "Derzeit befinden sich keine Personen in dieser Zone",
        "create_dialog_where_title": "Wo möchten Sie diese Zone platzieren?",
        "create_dialog_where_map": "Ich werde die Position manuell auf der Karte auswählen",
        "create_dialog_where_input": "An eine Adresse",
        "delete_disabled_ams_or_beacons": "Diese Zone wird in AMS verwendet oder verfügt über verknüpfte Beacons",
        "delete_disabled_links_or_triggers": "Diese Zone wird in einem Kundenlink oder Beobachtungsauslöser verwendet",
        "zones_with_similar_prints": "Es gibt %{smart_count} Zonenpaare mit ähnlichen Daten. Klicken Sie hier, um mehr anzuzeigen. |||| Es gibt %{smart_count} Zonenpaare mit ähnlichen Daten. Klicken Sie hier, um mehr anzuzeigen.",
        "customers_with_same_codes": "Beacon-Codes, die in Fingerabdrücken in verschiedenen Kundenumgebungen gefunden wurden. Klicken Sie hier für weitere Informationen.",
        "zones_with_similar_prints_title": "Zonen mit ähnlichen Drucken",
        "customers_with_same_codes_title": "Kunden mit gleichem Code/gleichen Codes",
        "not_fingerprinted_zones": "Zonen mit keinen oder eingeschränkten Fingerabdrücken",
        "zones_with_bad_prints": "Es gibt Zonen mit Fingerabdrücken, die nicht über genügend Beacons verfügen, um von Qualität zu sein. Klicken Sie hier, um mehr zu sehen",
        "zones_with_bad_prints_title": "Bereiche mit schlechten Drucken",
        "beacon_calc": {
          "open_button": "Zimmer berechnen",
          "dialog_title": "Berechnete Zimmer",
          "table": {
            "beacons": "Leuchtfeuer",
            "room_size": "Größe",
            "room_number": "Nummer",
            "total_square_meters": "Gesamt m²",
            "beacon_number": "Geschätzte Anzahl der Beacons",
            "fingerprint_time": "Fingerabdrücke",
            "beacon_place_time": "Montage von Beacons",
            "total_time": "Gesamt",
            "small": "Klein",
            "medium": "Mittel",
            "large": "Groß"
          },
          "hours": "Ihre |||| uren",
          "minutes": "Minute |||| Minuten"
        },
        "add_screen_subtext": "Generieren Sie eine Bildschirm-URL",
        "no_zones": "Erstellen Sie zuerst eine Zone",
        "delete_disabled_kiosks": "Diese Zone wird in einem Kiosk verwendet und sollte nicht gelöscht werden.",
        "filter_in_bounds": "Aus Karte herausfiltern",
        "update_dialog_title": "Möchten Sie diese Zone aktualisieren?",
        "update_dialog_content": "Diese Zone ist mit einem Fingerabdruck versehen. Durch die Aktualisierung dieser Zone können die Fingerabdrücke ungenau werden. Möchten Sie diese Zone aktualisieren?",
        "delete_disabled_fingerprinted": "Diese Zone dient zur Standortbestimmung in Innenräumen",
        "alarm_professional_responder_count_dialog_title": "Anzahl der Sequix pro Zone",
        "alarm_professional_responder_count_empty": "Zonen konnten nicht abgerufen werden"
      },
      "filters": {
        "only_show": "Nur zeigen"
      },
      "fields": {
        "type": "Typ",
        "description": "Beschreibung",
        "number_of_responders": "Anzahl der statischen Responder",
        "responsePriority": "Antwortpriorität",
        "number_of_beacons": "Anzahl der Beacons",
        "number_of_assets": "Anzahl der Assets innerhalb dieser Zone",
        "syncToAms": "Mit AMS synchronisieren",
        "alarm_position": "Alarmposition",
        "fingerprintCount": "Anzahl der Fingerabdrücke",
        "has_address_position": "Die Adresse der Zone wird für Alarme und die Personenlokalisierung verwendet.",
        "postCodeRange": "Postleitzahlenbereich",
        "postCodeRange_helper": "Beispiel: 7413-7451, 7499",
        "postCodeRange_label": "Postleitzahlenbereich",
        "alarm_professional_responder_count_sequrix": "Anzahl der Sequix in der Zone",
        "alarm_professional_responder_count_no_sequrix": "Anzahl anderer Einsatzkräfte in der Zone",
        "alarm_professional_responder_count_responders": "Graf Sequox"
      }
    },
    "contact-lists": {
      "text": {
        "title": "Kontaktlisten",
        "contacts_number": "Anzahl der Kontakte"
      },
      "fields": {
        "contacts": "Kontakte"
      }
    },
    "report-triggers": {
      "text": {
        "title": "Auslöser melden",
        "granularity_types": {
          "minute": "Protokoll)",
          "hour": "Std)",
          "day": "Tage)",
          "week": "Wochen)",
          "month": "Monat(e)",
          "quarter": "Viertel(e)",
          "year": "Jahre)"
        },
        "config_types": {
          "unhealthyBeacons": "Ungesunde Beacons",
          "observation": "Beobachtungsanzahl",
          "alarms": "Alarm",
          "newAlarm": "Neuer Alarm",
          "inactivityMonitor": "Inaktivitätsmonitor",
          "appUsage": "App-Nutzung",
          "assetHistory": "Vermögenshistorie",
          "alarmCenterStatus": "Alarmcenter-Status",
          "zoneOverview": "Zonenübersicht",
          "subtext": {
            "alarms": "Der Alarmbericht sendet einen Bericht mit einer Übersicht über die seit der letzten Meldung aufgetretenen Alarme. Wenn diese Option aktiviert ist, wird der Bericht am nächsten Montag und jede Woche danach gesendet.",
            "appUsage": "Der App-Nutzungsbericht sendet einen Bericht mit einer Übersicht über die Nutzung der App pro Benutzer im letzten Monat. Wenn diese Option aktiviert ist, wird der Bericht jeden Monat zu Beginn des Monats gesendet.",
            "inactivityMonitor": "Der Inaktivitätsüberwachungsbericht wird ausgelöst, wenn eine Schaltfläche mindestens 24 Stunden lang nicht online angezeigt wird. Dies weist darauf hin, dass die Taste nicht richtig funktioniert, entweder weil die Batterie schwach ist, sie sich außerhalb der Reichweite des Gateways befindet oder ein physischer Defekt vorliegt. In der gesendeten E-Mail wird angegeben, was zu tun ist.",
            "unhealthyBeacons": "Der Bericht über fehlerhafte Beacons enthält Beacons, die in letzter Zeit nicht gesehen wurden oder deren Akku fast leer ist. Der Versand erfolgt einmal pro Woche, montags.",
            "alarmCenterStatus": "Der Statusbericht der Alarmzentrale enthält Informationen über die Anzahl der an die Alarmzentrale eskalierten Alarme.",
            "newAlarm": "Der neue Alarmbericht wird gesendet, wenn ein neuer Alarm erstellt wird. Es wird nur gesendet, wenn der Alarm den Schweregrad „Orange“ oder „Rot“ hat."
          }
        },
        "config": {
          "excel_types": {
            "default": "Standard",
            "smc": "SMC"
          }
        },
        "channel_types": {
          "contact_list": "Kontaktliste"
        },
        "go_contactlist": "Klicken Sie hier, um zur Kontaktliste(n) zu gelangen.",
        "licence_modes": {
          "hourlyUsage": "Stündliche Nutzung",
          "license": "Lizenz"
        },
        "filter_tags": {
          "active": "Aktiv",
          "inactive": "Inaktiv",
          "new": "Neu",
          "forgotten": "Vergessene"
        },
        "invalid_email": "Eine oder mehrere ungültige E-Mail(s)",
        "not-exists": "Trigger existiert nicht mehr",
        "theme": {
          "default": "Standard (X-Guard)",
          "bhvk": "BHV-Knop.nl"
        },
        "send-for-current-month": "Senden Sie auch für den aktuellen Monat",
        "send-current-month-unavailable": "Dieser Bericht kann für diesen Monat nicht mehr versendet werden.",
        "unsubscribedEmails_helper": "An Adressen in diesem Feld wird dieser Bericht nicht gesendet."
      },
      "fields": {
        "config": {
          "type": "Typ",
          "last_seen_threshold": "Zuletzt gesehener Schwellenwert",
          "excelFormat": "Excel-Format",
          "alarmTypes": "Alarmtypen",
          "timeSeries_title": "Zeitfolgen",
          "severities": "Alarmschweregrade",
          "timeSeries": {
            "granularity": "Die Granularität",
            "timeframe": "Zeitfenster"
          },
          "app_mode": "App-Modus",
          "timeout": "Auszeit",
          "floorTo": "Etage bis",
          "agOptions": {
            "includeRaw": "Roh einbeziehen",
            "includeSimple": "Einfach einschließen"
          },
          "excludeCustomers": "Kunden ausschließen"
        },
        "enabled": "Ermöglicht",
        "lastRunAt": "Letzter Lauf um",
        "nextRunAt": "Nächster Lauf um",
        "runInterval_title": "Laufintervall",
        "channels": "Kanäle",
        "channels_type": "Typ",
        "channels_address": "Adresse",
        "time_granularity": {
          "value": "Menge",
          "type": "Zeit"
        },
        "channels_number": "Telefonnummern",
        "lastAttemptedAt": "Letzter Versuch",
        "unsubscribedEmails": "Abgemeldete E-Mail-Adressen"
      }
    },
    "unhealthyBeacons": {
      "text": {
        "inactive": {
          "label": "Inaktive Beacons"
        },
        "lowBattery": {
          "label": "Warnleuchten bei niedrigem Batteriestand"
        },
        "noneFound": "In diesem Kunden wurden keine Beacons gefunden",
        "noAttachments": "Keine Anhänge gefunden."
      }
    },
    "lite-templates": {
      "name": "QR-Codes"
    },
    "app_users": {
      "text": {
        "groups_and_config_explanation": "Wählen Sie unten Gruppen und Konfiguration aus. Auf Wunsch kann eine QR-Vorlage als Basis ausgewählt werden. Die ausgewählten Gruppen und Konfigurationen können für alle ausgewählten App-Benutzer festgelegt werden. Bei den Gruppen und der Konfiguration kann zwischen dem Ersetzen vorhandener Werte, dem Hinzufügen zu den vorhandenen Werten oder dem Überspringen der Gruppen oder Konfiguration gewählt werden. Wenn Überspringen ausgewählt ist, werden die Werte nicht bearbeitet."
      }
    },
    "domainlinks": {
      "title": "Domain-Einschränkungen"
    },
    "domainlink": {
      "fields": {
        "domain": "Domain"
      }
    },
    "buttons": {
      "text": {
        "manage_buttons": "Schaltflächen verwalten",
        "search": "Suchschaltflächen",
        "show_all": "Alle Schaltflächen anzeigen",
        "coordinates_small": " (Ziehen Sie den Punkt auf der Karte)",
        "gateway_map_disclaimer": "Der Kreis um eine Basisstation ist nur ein Hinweis auf die Reichweite.",
        "mass_move_title": "Mehrere Schaltflächen verschieben",
        "move_confirm_button": "Bewegen",
        "mass_move_explanation": "Schritt 2: Wählen Sie die Adresse",
        "button_number_tooltip": "Die Tastennummer ist auf einem Aufkleber auf der Unterseite aufgedruckt",
        "gateway_number_tooltip": "Die Nummer des Gateways ist auf der Rückseite des Geräts aufgedruckt",
        "test_button_title": "Sie erhalten eine Benachrichtigung",
        "test_button_content": "Diese Benachrichtigung geht nur an Sie, nicht an alle verfügbaren BHV-Mitglieder. Möchten Sie mit allen verfügbaren Mitarbeitern testen, drücken Sie tatsächlich den Knopf.",
        "test_sent": "Test gesendet, Sie erhalten diesen Alarm per Anruf",
        "test_disabled": "Test deaktiviert, da der angemeldete Benutzer keine gültige Methode zum Empfangen des Alarms hat",
        "print_all_labels": "Drucken Sie alle Etiketten",
        "print_all_labels_confirm": "Sind Sie sicher, dass Sie alle Etiketten drucken möchten?",
        "sufficient_battery": "Leere Batterie",
        "show_buttons": "Schaltflächen anzeigen",
        "building_dialog": {
          "0": {
            "title": "Fügen Sie ein Gebäude hinzu",
            "explanation": "Basierend auf der gefundenen Adresse versuchen wir automatisch, Ihr Gebäude mit den verfügbaren Daten aus der Katasterkarte zu laden.",
            "input_label": "Suchen Sie nach der Adresse...",
            "input_upper_label": "Suchen Sie nach Ihrer vollständigen Adresse"
          },
          "1": {
            "title": "Gebäude gefunden",
            "explanation": "Wir haben ein Gebäude gefunden. Ist das Ihr Gebäude? Wenn dies nicht korrekt ist, wählen Sie das richtige Gebäude auf der Karte aus und fahren Sie fort.",
            "surface_area": "Fläche %{area} m²",
            "next_button": "Fahren Sie mit dem ausgewählten Gebäude fort",
            "building_count": "Gebäude"
          },
          "2": {
            "title": "Wählen Sie die Anzahl der Etagen aus",
            "how_many_floors": "Wie viele Stockwerke hat das Gebäude?",
            "floors": "Böden",
            "next_button": "Sehen Sie sich den Vorschlag an",
            "next_builing_button": "Nächstes Gebäude",
            "office_or_factory": "Was beschreibt dieses Gebäude am besten?",
            "office": "Büro",
            "factory": "Fabrik oder Halle",
            "button_distance_title": "Abstand zwischen den Tasten",
            "button_distance_sub_title": "Wir empfehlen einen Abstand von 30 Metern.",
            "button_distance_button": "%{distance} Meter",
            "recommended": "Empfohlen"
          },
          "3": {
            "title": "Unser Angebot",
            "next_button": "Fügen Sie die Produkte hinzu",
            "view_price": "Zeigen Sie mir die Kosten"
          },
          "no_streetnumber": "Für die ausgewählte Adresse wurde keine Hausnummer gefunden",
          "change_later": "Sie können dies später problemlos ändern",
          "building": "Gebäude",
          "not_in_countries": "Bitte wählen Sie eine Adresse in den Niederlanden aus.",
          "max_buildings": "Es wird empfohlen, nicht mehr als %{count} Gebäude gleichzeitig hinzuzufügen",
          "no_buildings_found": "An der angegebenen Adresse wurden keine Gebäude gefunden"
        },
        "map_default": "Karte",
        "map_satellite": "Satellit",
        "map_center": "Center",
        "floors_chosen": "Böden ausgewählt",
        "all_floors": "Alle Etagen",
        "actions_with_selected": "Aktionen mit ausgewählt",
        "mass_move": "Bewegen",
        "add_gateway": "Gateway hinzufügen",
        "add_button": "Schaltfläche „Hinzufügen“.",
        "create_dialog_title_gateway": "Wo möchten Sie dieses Gateway platzieren?",
        "create_dialog_title_button": "Wo möchten Sie diese Schaltfläche platzieren?",
        "how_many_gateways": "Wie viele Gateways möchten Sie hinzufügen?",
        "how_many_buttons": "Wie viele Schaltflächen möchten Sie hinzufügen?",
        "no_concept_devices": "Auf Ihren ausgewählten Geräten wurden keine unbezahlten Notruftasten oder Gateways gefunden",
        "unpaid_devices": "Sie haben unbezahlte Produkte",
        "delete_unpaid": "Löschen Sie diese Produkte",
        "deleted_unpaid_devices": "Unbezahlte Geräte gelöscht",
        "delete_are_you_sure": "Möchten Sie diese unbezahlten Geräte wirklich löschen?",
        "delete_add_again": "Diese Geräte können einfach wieder hinzugefügt werden",
        "deleted_unpaid_devices_error": "Beim Löschen der ausgewählten Geräte ist ein Fehler aufgetreten.",
        "not_ordered": "Noch nicht bestellt",
        "place_button": "Schaltfläche(n) platzieren",
        "place_gateway": "Platzieren Sie Gateways",
        "stop_placing": "Hören Sie auf, Geräte zu platzieren",
        "status": {
          "online": "Dieses Gerät ist online",
          "offline": "Dieses Gerät ist offline",
          "pending": "Der Status dieses Geräts wird abgerufen",
          "empty": "Der Akku dieses Geräts ist (fast) leer",
          "lowRSSI": "Zu weit entfernt",
          "highNoise": "Das Radiosignal ist verrauscht",
          "nobody_why": "Niemand hat Kontakt aufgenommen, lesen Sie hier warum"
        },
        "deviceType": "Gerätetyp",
        "remove_filters": "Filter entfernen",
        "save_filters": "Filter speichern",
        "active_status_label": "Aktiver Status",
        "active_status": {
          "active": "Geordnete und aktive Schaltflächen",
          "unpaid": "Unbezahlte Geräte",
          "demo": "Demogeräte"
        },
        "all_devices": "Alle Arten von Geräten",
        "devices_chosen": "Gerätetypen ausgewählt",
        "all_active_status": "Alle Status",
        "active_status_chosen": "Status gewählt",
        "building_distance_warning": "Die ausgewählten Gebäude liegen weit auseinander. Prüfen Sie, ob diese Gebäude zur selben Adresse oder zum selben Komplex gehören. Sie können später problemlos weitere Adressen hinzufügen.",
        "create_alarm_uncontacted": "%{smart_count} bisher nicht kontaktierte Person |||| %{smart_count} bisher nicht kontaktierte Personen",
        "invalid_address": "Die eingegebene Adresse ist ungültig. Nur gültige Adressen in den Niederlanden werden akzeptiert.",
        "locked": "Gesperrt",
        "unlocked": "Freigeschaltet",
        "create_alarm_confirm_title": "Möchten Sie für diese Schaltfläche wirklich einen Alarm erstellen?",
        "create_alarm_current_address": "Aktuelle Adresse:",
        "print_selected_labels": "Drucken Sie ausgewählte Etiketten",
        "print_selected_labels_confirm": "Möchten Sie die ausgewählten Etiketten wirklich drucken?",
        "print_selected_labels_notify": "Ausgewählte Etiketten werden gedruckt",
        "print_all_labels_notify": "Alle Etiketten sind gedruckt",
        "no_labels_selected": "Es wurden keine Etiketten mit gültiger ID zum Drucken ausgewählt.",
        "print_labels_error": "Fehler beim Drucken der Etiketten"
      },
      "fields": {
        "address": "Textadresse"
      },
      "automove_title": "Schaltflächen automatisch verschieben",
      "groups_selected": "Ausgewählte Gruppen",
      "automove_no": "Nein, aktuelle Position beibehalten"
    },
    "notifications": {
      "move_multiple_no_location": "Bitte wählen Sie einen Standort aus, bevor Sie auf „Verschieben“ klicken",
      "moved_multiple": "Schaltflächen und/oder Gateways wurden verschoben.",
      "moved_multiple_error": "Beim Verschieben ist ein Fehler aufgetreten. Ein oder mehrere wurden möglicherweise nicht verschoben."
    },
    "report_triggers": {
      "text": {
        "to_whom": "An wen?",
        "specific_fields": "Berichtstypspezifische Felder"
      },
      "what_report": "Welcher Bericht?"
    },
    "roles": {
      "title": "Rollen"
    },
    "reports": {
      "title": "Berichte",
      "text": {
        "attached_email": "E-Mail generiert",
        "show_email": "E-Mail anzeigen",
        "sub_title": "Die verschiedenen Berichte finden Sie auf dieser Seite. Hier können Sie dies auch ein-/ausschalten und festlegen, an wen der Bericht gesendet werden soll. Fehlt Ihnen ein Bericht? Kontaktiere uns.",
        "recipients": "Empfänger",
        "no_recipients": "Dieser Bericht wird an keinen Empfänger gesendet. Dies ist keine korrekte Konfiguration.",
        "confirm_dialog_content": "Möchten Sie diesen Bericht wirklich deaktivieren?",
        "settings": "Berichtseinstellungen",
        "hour": "%{smart_count} Stunde |||| %{smart_count} Stunden",
        "day": "%{smart_count} Tag |||| %{smart_count} Tage",
        "week": "%{smart_count} Woche |||| %{smart_count} Wochen",
        "zones_no_data": "Auf dieser Seite können Sie sehen, wer sich in der Vergangenheit in Ihren Zonen aufgehalten hat. \n\nSo können Sie sicherstellen, dass zum gewünschten Zeitpunkt genügend Personen anwesend waren.",
        "zones_settings_title": "Live-Verfügbarkeitsbericht",
        "zones_settings_explain": "Dieser Bericht zeigt live die aktuelle und vorherige Belegung in den ausgewählten Zonen.",
        "zones_settings": {
          "zone_helpertext": "Für welche Zonen möchten Sie die Diagramme anzeigen?",
          "period_helpertext": "Wählen Sie, wie lange Sie zurückblicken möchten. Bei einem längeren Zeitraum werden die angezeigten Daten ungenauer.",
          "period": "Zeitraum",
          "min_occupancy_helpertext": "Wählen Sie optional aus, wie viele Personen anwesend sein sollen. Dies ist beispielsweise die gewünschte Anzahl an Einsatzkräften.",
          "includeGroups_helpertext": "Wählen Sie aus, welche Benutzergruppen als Belegung gezählt werden können.",
          "inactivityThreshold": "Aktivität in der App erforderlich",
          "occupancy_title": "Wie viele Personen möchten Sie dabei haben?",
          "schedule": "Wann ist dies erforderlich?",
          "zone_title": "Welche Zone möchten Sie überwachen?",
          "enabled": "Bei Personalmangel per E-Mail benachrichtigen",
          "schedule_warning": "Wenn Sie keinen Zeitplan hinzufügen, muss die gewünschte Belegung immer erreicht werden.",
          "asset_groups": "Welche Gruppen möchten Sie überwachen?"
        },
        "zones_no_groups": "Es sind keine zu überwachenden Zonen vorhanden. Sie können Zonen über die Seite „Zonen“ hinzufügen.",
        "month": "%{smart_count} Monat |||| %{smart_count} Monate",
        "subtext_week": "jede Woche |||| %{smart_count} Wochen",
        "subtext_month": "jeden Monat |||| %{smart_count} Monate",
        "subtext_day": "jeden Tag |||| alle %{smart_count} Tage",
        "subtext_hour": "jede Stunde |||| alle %{smart_count} Stunden",
        "subtext_quarter": "jedes Quartal |||| alle %{smart_count} Quartale",
        "subtext_year": "jeden Tag |||| alle %{smart_count} Tage",
        "add_zone": "Neue Zone überwachen",
        "zone_monitor_added": "Überwachung gestartet",
        "zone_monitor_updated": "Monitoring aktualisiert",
        "sends_email": "E-Mail-Benachrichtigungen",
        "bhvk_title": "Verfügbarkeit in Zonen",
        "zone_monitor_loading_secondary": "Verfügbarkeit wird geladen, bitte warten …",
        "zoneOverview_filter_assets": "Nur ausgewählte Personen anzeigen",
        "zoneOverview_filter_assets_tooltip": "Diagramm nach Personen filtern",
        "zoneOverview_asset_settings": "Wählen Sie die Personen aus, die Sie im Diagramm sehen möchten.",
        "last_week": "Letzte Woche",
        "last_month": "Letzten Monat",
        "zoneOverview_timeseries_settings": "Wählen Sie Ihre Grafik pro Woche aus und lassen Sie sie los"
      },
      "fields": {
        "attachments": "Anhänge",
        "last_attachments": "Letzte E-Mail anzeigen",
        "minOccupancy": "Mindestbelegung",
        "occupancy": "Belegung",
        "enable_warnings": "Warnungen aktivieren",
        "enable_weekly": "Wöchentliche E-Mails aktivieren",
        "enable_monthly": "Monatliche Aktivierung",
        "enable_emails": "Möchten Sie E-Mails zu diesem Diagramm erhalten?",
        "hasAttachment": "Senden Sie eine Anlage mit der Liste der Personen, die sich täglich in dieser Zone aufgehalten haben."
      },
      "title_single": "Bericht"
    },
    "report-trigger-runs": {
      "title": "Berichte",
      "empty": "Noch keine Berichte"
    },
    "kiosk-users": {
      "title": "Zeigt an",
      "default_config": "Verwendet die Standardkonfiguration",
      "text": {
        "config_not_set": "Konfiguration nicht festgelegt",
        "created": "Bildschirmbenutzer erstellt",
        "set_zone": "Fehler: Legen Sie eine Zone fest"
      },
      "fields": {
        "kioskConfig": {
          "managed": "Gelang es"
        },
        "fully_android_id": "Vollständige Kiosk-Android-ID",
        "fully_device_id": "Vollständige Kiosk-Geräte-ID",
        "managed": "X-Guard verwaltet"
      },
      "url_dialog_title": "Ihre Kiosk-URL",
      "url_dialog_privacy": "Mir ist bewusst, dass diese URL Zugriff auf potenziell vertrauliche Informationen meiner Organisation bietet.",
      "url_dialog_show_once": "Ich verstehe, dass diese URL nur einmal angezeigt wird. Es wird nicht mehr angezeigt und wenn ich es verliere, muss eine neue URL generiert werden.",
      "url_dialog_use_once": "Ich verstehe, dass diese URL nur auf einer Anzeige verwendet werden kann. Wenn Sie über mehr Anzeigen verfügen, erstellen Sie in diesem Dashboard weitere Bildschirme.",
      "kiosk_number": "Kiosknummer",
      "url_dialog_agree": "Mir ist bewusst, dass dadurch die URL neu generiert wird. Die alte, vorhandene URL funktioniert nicht mehr."
    },
    "qr-code": {
      "text": {
        "single": "QR-Code"
      }
    },
    "fingerprints": {
      "text": {
        "progress_zones": "Fingerabdruckzonen",
        "progress_devices_in_fingerprint": "Geräte in Fingerabdrücken",
        "progress_beacons_in_fingerprint": "Anzahl der Beacons in Fingerabdrücken",
        "is_similar_to": "Ist ähnlich wie",
        "similar_scans": "Ähnliche Scans",
        "other_customer": "Anderer Kunde",
        "create_beacons": "Beacons für Codes in Fingerabdrücken erstellen",
        "missing_codes": "Codes fehlender Beacons",
        "create_beacons_button": "Beacons erstellen",
        "beacons_created": "%{smart_count} Beacon erstellt ||| %{smart_count} Beacons erstellt",
        "beacons_not_created": "Beacons konnten nicht erstellt werden",
        "check_beacons": "Prüfen Sie, ob Beacons erstellt werden müssen",
        "check_progress": "Fortschritt und Integrität des Fingerabdrucks prüfen",
        "disable_statistics": "Fortschritt und Gesundheit deaktivieren",
        "change_zones": "Wechselzone",
        "bulk_action_buttons_title": "Änderungszonen ausgewählter Fingerabdrücke",
        "change_zones_description": "Möchten Sie wirklich die Zone der %{smart_count} Fingerabdrücke ändern?",
        "change_zones_confirmation": "Mir ist bewusst, dass eine Änderung der Zone das Risiko für eine genaue Standortbestimmung birgt.",
        "zone_changed": "Zone aktualisiert!",
        "error_changing_zone": "Fehler beim Aktualisieren der Zone"
      },
      "fields": {
        "userId": "Fingerabdrücke von"
      }
    },
    "kiosks": {
      "text": {
        "manage": "Bildschirme verwalten",
        "add_kiosk": "Kiosk hinzufügen",
        "add_screen": "Bildschirm hinzufügen",
        "general_settings_dialog": {
          "title": "Allgemeine Kioskeinstellungen",
          "switch_availability": "Verfügbarkeit"
        },
        "kioskConfig": {
          "homepage": {
            "incidentCounter": {
              "last_alarm": "Vom letzten Alarm"
            }
          }
        },
        "general_settings_updated": "Kioskeinstellungen aktualisiert",
        "menu_title": "Kiosk-Karte",
        "create_dialog_title": "Kiosk erstellen",
        "create_dialog_title_screen": "Bildschirm-URL erstellen",
        "zone_not_found": "Zone nicht gefunden, wird nicht erstellt ...",
        "kiosk_deleted": "Kiosk gelöscht",
        "kiosk_delete_title": "Kiosk %{name} löschen",
        "kiosk_created": "Kiosk erstellt!",
        "kiosk_created_screen": "Bildschirm erstellt!",
        "zone_warning": "Dieser Kiosk wird beim Speichern in die Mitte der ausgewählten Zone verschoben.",
        "admin_actions": {
          "button": "Administratoraktionen"
        },
        "kiosk_moved": "Kiosk umgezogen!",
        "kiosk_move_title": "Kiosk „%{name}“ verschieben",
        "kiosk_regenerated": "Kiosk-Anmeldeinformationen neu generiert. Alte URL nicht mehr verwendbar",
        "kiosk_regenerate_button": "Anmeldeinformationen neu generieren",
        "kiosk_regenerate_title": "URL für „%{name}“ neu generieren.",
        "customer_admin_create_dialog_content": "Kioske sind eine großartige Möglichkeit, sowohl anzuzeigen als auch zu verwalten, wer in Ihrer Organisation verfügbar ist.\n\n## Anwesenheitserkennung mit dem BHV-Knop.nl-Kiosk\nKioske richten sich hauptsächlich an unternehmensinterne Notfallteams.\n\n[Lesen Sie mehr über Anwesenheitserkennung](https://bhv-knop.nl/en/hoe-werkt-het/aanwezigheidsdetectie/ (Englisch))\n\n## Hardware\nWir bieten eine vollständig verwaltete Lösung mit unseren praktischen Touchscreens. Hauptsächlich auf unsere BHV-Knop.nl-Kunden ausgerichtet.\n\nKontaktieren Sie Ihren Account Manager für weitere Informationen.\n\n![Kioskbeispiel](https://bhv-knop.nl/wp-content/uploads/2024/02/kiosks-663x1024.png)\n\n## Zeigen Sie einen Kiosk auf Ihren eigenen vorhandenen Bildschirmen an\nWir bieten die Möglichkeit, den Kiosk auf Ihren vorhandenen Unternehmensbildschirmen anzuzeigen. Sie erhalten eine Webbrowser-URL zur Anzeige auf dem Bildschirm.\n\nSie besitzen diese Lizenz derzeit nicht. Weitere Informationen erhalten Sie von Ihrem Account Manager.",
        "general_settings": {
          "overwrite": "Standardkonfiguration überschreiben"
        },
        "default_config": "Konfigurieren",
        "kiosk_preview": "Kiosk-Vorschau",
        "create_mode_dialog_title": "Möchten Sie einen neuen Kiosk oder Bildschirm erstellen?",
        "add_kiosk_subtext": "Hinzufügen eines verwalteten Kiosks",
        "status": {
          "online": "Kiosk in den letzten 30 Minuten gesehen",
          "offline": "Kiosk in den letzten 30 Minuten nicht gesehen."
        },
        "none_yet": "Noch keine Kioske",
        "edit_single_confirm_content": "Möchten Sie wirklich einen einzelnen Kiosk bearbeiten? Sie können auch die allgemeinen Kioskeinstellungen für dieses Konto bearbeiten.",
        "edit_single_confirm_title": "Möchten Sie wirklich einen einzelnen Kiosk bearbeiten?",
        "edit_single_confirm_cancel": "Nein, die allgemeinen Einstellungen für Kioske bearbeiten",
        "edit_single_confirm_confirm": "Ja, mit der Bearbeitung fortfahren",
        "publish": "Auf %{count} Kiosken veröffentlichen",
        "defaults": "Standard-Kioskeinstellungen",
        "menu_title-beta": "Kioske (Beta)",
        "kiosk_created_but_failed_to_sync_zone_in_client_config": "Kiosk erstellt, aber Zone konnte nicht synchronisiert werden"
      }
    },
    "groups": {
      "text": {
        "bhvk-explanation": "Dies ist eine Gruppe."
      }
    },
    "auditlogs": {
      "text": {
        "subject": "Thema",
        "user": "Benutzer",
        "operation": "Aktion",
        "title": "Überwachungsprotokolle",
        "resource_types": "Ressourcentypen",
        "expose_users": "Benutzer offenlegen"
      }
    },
    "customer-alarm-center-relations": {
      "title": "Alarmzentralen",
      "fields": {
        "enabled": "Ermöglicht",
        "priority": "Priorität"
      },
      "name": "Alarmzentralenbeziehung"
    },
    "config": {
      "text": {
        "defaults_updated": "Kiosk-Standardeinstellungen aktualisiert",
        "defaults_update_error": "Fehler beim Aktualisieren der Standardeinstellungen. Ein oder mehrere Schlüssel wurden nicht aktualisiert.",
        "no_access": "Kein Zugriff"
      }
    },
    "registration-templates": {
      "fields": {
        "profile": {
          "assetGroups": "Asset-Gruppen",
          "legacyConfigGroups": "Legacy-Konfigurationsgruppen",
          "configGroups": "Konfigurationsgruppen",
          "assetGroupLimit": "Auf Gruppen beschränken"
        },
        "numberUsed": "Verwendete Nummer"
      },
      "text": {
        "title": "Registrierungsvorlagen"
      }
    },
    "legacy-domainlinks": {
      "title": "Domänenbeschränkungen (Legacy)"
    },
    "alarm-call-phone-numbers": {
      "fields": {
        "phoneNumber": "Telefonnummer",
        "type": "Typ",
        "numberOfAssetGroupsAndAssets": "Anzahl der Anlagegruppen/Anlagen",
        "timesCalled": "Die Times nannten",
        "lastTimeCalled": "Letztes Mal angerufen bei"
      },
      "type": {
        "general": "Allgemein",
        "additional": "Zusätzlich"
      },
      "lastTimeCalled": {
        "neverCalled": "Niemals"
      },
      "text": {
        "page_info": "Jeder Eintrag in dieser Tabelle führt zu seiner Konfigurationsseite. Änderungen an diesen Konfigurationen können sich auf die Alarmreaktion und die Alarmauslösung auswirken.\nAuf dieser Seite können Sie die Telefonnummern eines Kunden einsehen und bearbeiten sowie deren Konfiguration über die entsprechenden Schaltflächen anzeigen oder ändern.",
        "general_customer_config_button": "Allgemeine Kundenkonfigurationen",
        "addGeneral": "Allgemeine Nummer hinzufügen",
        "addAdditional": "Fügen Sie eine weitere Zahl hinzu",
        "add_general_number_button": "Hinzufügen",
        "buy_additional_number_button": "Kaufen",
        "selectInput": {
          "selectCountry": "Land auswählen",
          "options": {
            "countryID": "Niederlande",
            "countryName": "Niederlande"
          }
        },
        "successMessage": {
          "addGeneral": "Het algemene telefoonnummer is succesvol toegevoegd",
          "addAdditional": "Die zusätzliche Telefonnummer wurde erfolgreich hinzugefügt"
        },
        "errorMessage": {
          "addGeneral": "Allgemeine Telefonnummer konnte nicht hinzugefügt werden",
          "addAdditional": "Es ist fehlgeschlagen, eine zusätzliche Telefonnummer hinzuzufügen."
        },
        "generalConfig": {
          "title": "Algemene configuraties",
          "manageCustomer": "Kundenverwaltung"
        },
        "unlink_customer_button": "Unlink-Kunde"
      },
      "title": "Alarmruf-Telefonnummern",
      "create": {
        "title": "Telefonnummer erstellen"
      }
    },
    "certification-categories": {
      "title": "Zertifizierungskategorien",
      "fields": {
        "validity_period": "Gültigkeitszeitraum",
        "is_certification_holder_notified": "Benachrichtige den Benutzer, dessen Zertifizierung abläuft.",
        "is_documentary_proof_required": "Erfordert einen Dokumentennachweis",
        "people_to_notify": "Personen, die benachrichtigt werden sollen",
        "custom_reminder_periods": "Benutzerdefinierte Erinnerungszeiträume",
        "reminder_periods": "Erinnerungszeiträume",
        "certified_user": "Zertifizierter Benutzer"
      },
      "text": {
        "create_title": "Erstellen Sie eine neue Zertifizierungskategorie",
        "category_explanation": "Zertifizierungskategorien dienen dazu, festzulegen, welche Zertifikate die Benutzer Ihrer Organisation erhalten können. Beispielsweise können Sie eine Zertifizierungskategorie für „BHV Responder“ erstellen und anschließend diese Art von Zertifizierung für die Dashboard-Benutzer festlegen.",
        "certified_users": "zertifizierte Benutzer",
        "certified_users_dialog_title": "Zertifizierte Benutzer für",
        "certified_users_dialog_empty": "Für diese Kategorie gibt es keine zertifizierten Benutzer.",
        "count": "Zählen",
        "expiring": "ablaufen",
        "title_single": "Zertifizierungskategorie",
        "expiring_certifications_dialog_title": "Ablaufende Zertifizierungen für",
        "days_until_expiry": "Tage bis zum Ablauf",
        "already_expired_for": "Bereits abgelaufen für",
        "edit_confirmation_dialog_title": "Bearbeitung bestätigen",
        "edit_confirmation_dialog_content": "Sind Sie sicher, dass Sie den Nachweis von Dokumenten auf „nicht erforderlich“ setzen möchten? Dadurch werden alle vorhandenen Nachweisdokumente für diese Kategorie gelöscht.",
        "expires_today": "Läuft heute ab",
        "add_from_presets_title": "Zertifizierungskategorien aus Voreinstellungen hinzufügen",
        "add_from_presets_subtitle": "Sie können Ihrer Organisation Zertifizierungen aus Voreinstellungen hinzufügen.",
        "custom_reminder_create": "+ Erstellen",
        "custom_reminder_period_title": "Füge einen benutzerdefinierten Erinnerungszeitraum hinzu.",
        "no_results": "Ihre Suche ergab keine Ergebnisse.",
        "name_helper": "Zum Beispiel \"BHV-Zertifizierung\"",
        "validity_period_helper": "Wie lange ist eine Zertifizierung dieses Typs gültig?",
        "people_to_notify_helper": "Wer soll Benachrichtigungen über ablaufende Zertifizierungen erhalten?",
        "reminder_periods_helper": "Wie lange vor dem Ablauf sollen die E-Mails versendet werden? Es können mehrere Optionen ausgewählt werden",
        "documentary_proof_helper": "Ist es erforderlich, einen Scan des Zertifikats hochzuladen?",
        "filter_by": "Filtern nach",
        "expired": "abgelaufen",
        "valid": "gültig",
        "user_count": "Benutzeranzahl",
        "certified": "zertifiziert",
        "expiring_certifications_dialog_empty": "Keine ablaufenden Zertifizierungen für diese Kategorie",
        "expired_certifications_dialog_empty": "Keine abgelaufenen Zertifizierungen für diese Kategorie",
        "expired_certifications_dialog_title": "Abgelaufene Zertifizierungen für",
        "users_dialog_title": "Zertifizierungen für",
        "users_dialog_empty": "Keine Benutzer für diese Kategorie gefunden",
        "add_category_dialog_title": "Zertifizierungskategorie hinzufügen",
        "preset_already_exists": "Eine Zertifizierungskategorie mit diesem Namen existiert bereits"
      },
      "presets": {
        "basic_emergency_response_officer": {
          "name": "Zertifizierung – Basic Emergency Response Officer (BHV)",
          "description": "Grundlegende Notfallmaßnahmenausbildung einschließlich Erster Hilfe, Brandbekämpfung und Evakuierung."
        },
        "bhv_team_leader": {
          "name": "Zertifizierung – BHV-Teamleiter",
          "description": "Leitung von Notfallteams bei Zwischenfällen und Evakuierungen."
        },
        "head_of_emergency_response": {
          "name": "Zertifizierung – Leiter der Notfallreaktion",
          "description": "Verantwortlich für die Organisation der Notfallmaßnahmen und die Koordination der Notfallverfahren."
        },
        "basic_vca": {
          "name": "Zertifizierung – Grundlegende VCA",
          "description": "Sicherheits-, Gesundheits- und Umweltzertifizierung für operative Mitarbeiter."
        },
        "vol_vca": {
          "name": "Zertifizierung - VOL-VCA",
          "description": "VCA-Zertifizierung für operative Vorgesetzte und Manager."
        },
        "forklift_certificate": {
          "name": "Zertifizierung – Gabelstaplerführerschein",
          "description": "Sicherer Betrieb von Gabelstaplern und internen Transportmitteln."
        },
        "reach_truck_certificate": {
          "name": "Zertifizierung – Schubmaststaplerzertifikat",
          "description": "Sicherer Betrieb von Schubmaststaplern in Lagerumgebungen."
        },
        "aerial_work_platform_certificate": {
          "name": "Zertifizierung – Zertifikat für Hubarbeitsbühnen",
          "description": "Sicherer Betrieb von Hubarbeitsbühnen und Hubarbeitsgeräten."
        },
        "nen_3140_skilled_person": {
          "name": "Zertifizierung – NEN 3140 Fachkraft",
          "description": "Qualifizierte Person für sicheres Arbeiten an elektrischen Anlagen."
        },
        "nen_3140_installation_responsible": {
          "name": "Zertifizierung - NEN 3140 Installationsverantwortlicher",
          "description": "Person, die für elektrische Installationen und die Einhaltung der Sicherheitsvorschriften verantwortlich ist."
        },
        "respiratory_protection": {
          "name": "Zertifizierung – Atemschutz",
          "description": "Schulung für den sicheren Umgang mit Atemschutzgeräten."
        },
        "working_at_height": {
          "name": "Zertifizierung – Arbeiten in der Höhe",
          "description": "Sicheres Arbeiten in der Höhe einschließlich Absturzsicherungsmaßnahmen."
        },
        "basic_first_aid": {
          "name": "Zertifizierung – Grundlegende Erste-Hilfe",
          "description": "Grundlegende Erste-Hilfe-Ausbildung und Notfallversorgung."
        },
        "pediatric_first_aid": {
          "name": "Zertifizierung – Erste Hilfe für Kinder",
          "description": "Erste Hilfe mit Schwerpunkt auf Babys und Kindern."
        },
        "sports_first_aid": {
          "name": "Zertifizierung – Erste Hilfe im Sport",
          "description": "Erste Hilfe mit Schwerpunkt auf Sportverletzungen und Akutversorgung bei sportlichen Aktivitäten."
        },
        "first_aid_refresher": {
          "name": "Zertifizierung – Erste-Hilfe-Auffrischungskurs",
          "description": "Jährliche Auffrischungsschulung für die Erste-Hilfe-Zertifizierung."
        },
        "cpr_aed": {
          "name": "Zertifizierung – HLW/AED",
          "description": "Schulung in Herz-Lungen-Wiederbelebung und im Umgang mit einem AED-Gerät."
        },
        "text": {
          "search": "Voreinstellungen suchen..."
        }
      }
    },
    "security-inventory-categories": {
      "title": "Inventarkategorien",
      "text": {
        "sub_title": "Sicherheitsrelevante Ausrüstung umfasst Gegenstände, die für die Sicherheit der Personen in Ihrem Unternehmen unerlässlich sind.\nSie können die Kategorien dieser Gegenstände in der folgenden Tabelle verwalten.",
        "settings_sub_title": "Sie können die Kategorieeinstellungen unten bearbeiten. Bitte füllen Sie alle Pflichtfelder aus.",
        "title_single": "Kategorie",
        "select_icon": "Wählen Sie ein Symbol aus",
        "add_from_presets_title": "Inventarkategorie aus Voreinstellungen hinzufügen",
        "add_from_presets_subtitle": "Nachfolgend finden Sie die voreingestellten Inventarkategorien. Wählen Sie eine Voreinstellung aus, um sie der Liste der in Ihrem Unternehmen verfügbaren Inventarkategorien hinzuzufügen.",
        "select_category": "Kategorie auswählen",
        "settings_button": "Kategorieneinstellungen",
        "create_title": "Erstellen Sie eine neue Artikelkategorie",
        "category_explanation": "Hier können Sie eine benutzerdefinierte Artikelkategorie hinzufügen, falls diese Kategorie in den Voreinstellungen nicht verfügbar ist.",
        "no_results": "Ihre Suche ergab keine Ergebnisse.",
        "name_helper": "Zum Beispiel \"Feuerlöscher\"",
        "people_to_notify_helper": "Wer soll Benachrichtigungen über ablaufende Artikel erhalten?",
        "reminder_periods_helper": "Wie lange vor dem Ablauf sollen die E-Mails versendet werden? Es können mehrere Optionen ausgewählt werden",
        "inspection_period_helper": "Wie lange ist ein Artikel dieses Typs gültig, bevor er erneut inspiziert werden muss?",
        "add_category_dialog_title": "Inventarkategorie hinzufügen",
        "preset_already_exists": "Eine Inventarkategorie mit diesem Namen existiert bereits"
      },
      "fields": {
        "inspection_period": "Prüfzeitraum",
        "people_to_notify": "Personen, die benachrichtigt werden sollen",
        "icon": "Symbol",
        "items_count": "Anzahl der Artikel"
      },
      "presets": {
        "text": {
          "search": "Voreinstellungen suchen..."
        }
      }
    },
    "customer_access_request": {
      "title": "Kundenzugriff anfordern",
      "fields": {
        "customer": "Kunde",
        "duration": "Zugriffsdauer",
        "reason": "Grund für den Zugriff",
        "force": "Erzwingungsanforderung",
        "role_preview": "Gewünschte Rolle"
      },
      "options": {
        "duration_1_day": "1 Tag",
        "duration_2_days": "2 Tage",
        "duration_1_week": "1 Woche",
        "duration_2_weeks": "2 Wochen"
      },
      "validation": {
        "customer_required": "Wählen Sie einen Kunden aus",
        "reason_min_length": "Der Grund muss mindestens 10 Zeichen lang sein.",
        "force_short_duration_only": "Erzwungene Anfragen sind nur für 1 oder 2 Tage zulässig.",
        "no_global_role": "Ihrem Konto fehlt für diese Anfrage eine globale Vertriebs- oder Supportrolle."
      },
      "notifications": {
        "submit_success": "Zugriffsantrag eingereicht",
        "request_granted": "Ihr Zugriffsantrag wurde genehmigt.",
        "request_denied": "Ihre Zugriffsanfrage wurde abgelehnt.",
        "already_pending": "Für diesen Kunden liegt bereits eine ausstehende Zugriffsanfrage vor."
      },
      "text": {
        "redirected_from_customer_switch": "Sie haben noch keinen Zugriff auf diesen Kunden. Stellen Sie eine Anfrage, um fortzufahren.",
        "already_pending": "Für diesen Kunden liegt bereits eine Zugriffsanfrage vor. Sie werden benachrichtigt, sobald diese geprüft wurde.",
        "open_request_locked_with_force": "Für diesen Kunden liegt bereits eine Zugriffsanfrage vor. Die unten stehenden Details können nicht geändert werden. Aktivieren Sie die Option „Zugriff erzwingen“, um den Zugriff jetzt zu erhalten. Administratoren werden über diese Aktion benachrichtigt."
      },
      "actions": {
        "submit": "Anfrage einreichen"
      }
    },
    "customer_access_review": {
      "title": "Überprüfung von Zugriffsanfragen",
      "fields": {
        "customer": "Kunde",
        "requested_by": "Angefordert von (Benutzer-ID)",
        "requested_role": "Gewünschte Rollen",
        "valid_until": "Gültig bis",
        "reason": "Grund",
        "force_requested": "Erzwungene Anfrage",
        "status": "Status",
        "column_actions": "Aktionen"
      },
      "status": {
        "open": "Offen",
        "approved": "Genehmigt",
        "rejected": "Abgelehnt"
      },
      "actions": {
        "reload": "Neu laden",
        "approve": "Genehmigen",
        "reject": "Ablehnen",
        "reject_reason": "Ablehnungsgrund"
      },
      "validation": {
        "reject_reason_min_length": "Der Ablehnungsgrund muss mindestens 10 Zeichen lang sein."
      },
      "text": {
        "cannot_review_own_request": "Sie können Ihre eigene Zugriffsanfrage nicht überprüfen.",
        "loading": "Laden…",
        "empty": "Es wurden keine Zugriffsanfragen gefunden."
      },
      "forced": {
        "yes": "Ja",
        "no": "NEIN"
      },
      "notifications": {
        "load_error": "Zugriffsanfragen konnten nicht geladen werden",
        "approve_success": "Antrag genehmigt",
        "reject_success": "Anfrage abgelehnt"
      },
      "switch": {
        "show_all": "Alle Anfragen anzeigen (einschließlich der geprüften)"
      }
    },
    "security-inventory-items": {
      "text": {
        "search": "Suchbegriffe...",
        "add_item": "Artikel hinzufügen",
        "no_results": "Keine Artikel gefunden",
        "add_item_dialog": "Wo möchten Sie diesen Gegenstand platzieren?",
        "place_item": "Platzieren Sie den Gegenstand",
        "item_lowercase": "Artikel",
        "delete_dialog_title": "Elemente löschen",
        "delete_content": "Sind Sie sicher, dass Sie diese Elemente löschen möchten?",
        "edit_item_title": "Element bearbeiten",
        "how_many_items": "Wie viele Artikel möchten Sie hinzufügen?",
        "expiry_date_input_helper_text": "Das Verfallsdatum wird automatisch aus dem Datum des letzten Wareneingangs zuzüglich des Verfallsdatums der Artikelkategorie vorbelegt. Sie können es bei Bedarf manuell ändern.",
        "all_categories": "Alle Kategorien",
        "categories_chosen": "Kategorien ausgewählt",
        "all_users": "Alle Benutzer",
        "users_chosen": "Benutzer ausgewählt",
        "filter_user": "Benutzer",
        "filter_category": "Kategorie",
        "renew_now_modal_title": "Jetzt verlängern",
        "renew_now_modal_helper_text": "Das Ablaufdatum wird anhand des letzten Inspektionsdatums plus des Ablaufintervalls der Artikelkategorie vorausgefüllt. Sie können es bei Bedarf manuell ändern.",
        "plan_renewal_modal_title": "Verlängerung planen",
        "add_planned_renewal_date": "Verlängerung an einem Datum planen",
        "remove_planned_renewal_date": "Geplantes Datum entfernen",
        "manage_inspection": "Inspektion verwalten",
        "choice_dialog_title": "Inspektion verwalten",
        "plan_inspection": "Inspektion planen",
        "plan_inspection_subtitle": "Planen Sie, wann die ausgewählten Artikel inspiziert werden sollen",
        "not_planned_yet": "Noch nicht geplant",
        "remove_planned_inspection_date": "Geplantes Inspektionsdatum entfernen",
        "confirm_move_marker_title": "Element auf der Karte verschieben?",
        "confirm_move_marker_content": "Der Standort wurde geändert. Möchten Sie dieses Element auf der Karte an den neuen Standort verschieben?",
        "expiry_date_manual_edit_helper_text": "Sie können dies manuell bearbeiten",
        "item": "1 Artikel |||| %{smart_count} Artikel",
        "planned_inspection_date_helper_text": "E-Mail-Benachrichtigungen werden bis zum geplanten Inspektionsdatum pausiert."
      },
      "fields": {
        "last_inspection_date": "Datum der letzten Inspektion",
        "expiry_date": "Verfallsdatum",
        "planned_renewal_date": "Geplantes Verlängerungsdatum",
        "planned_inspection_date": "Geplantes Inspektionsdatum",
        "identifier_placeholder": "id12345",
        "identifier": "Kennung"
      },
      "validation": {
        "expiry_date_must_be_future": "Das Ablaufdatum muss in der Zukunft liegen."
      },
      "presets": {
        "fire_extinguishers": {
          "name": "Feuer - Feuerlöscher",
          "description": "Tragbare Feuerlöscher; jährliche Überprüfung durch ein zertifiziertes Unternehmen."
        },
        "fire_doors": {
          "name": "Feuerschutztüren",
          "description": "Prüfen Sie, ob der Verschluss selbstschließend ist, ob die Dichtungen intakt sind und ob ein freier Schwenkbereich vorhanden ist."
        },
        "fire_dampers_ventilation": {
          "name": "Brandschutz - Brandschutzklappen (Belüftung)",
          "description": "Verhinderung der Brandausbreitung über Lüftungskanäle; Prüfung auf ordnungsgemäßen Verschluss."
        },
        "fire_alarm_system": {
          "name": "Brandmeldeanlage",
          "description": "Detektions- und Alarmsystem; Wartung durch Fachpersonal."
        },
        "fire_hose_reels": {
          "name": "Feuerwehr - Feuerwehrschlauchhaspeln",
          "description": "Prüfen Sie den Wasserdruck, den Zustand des Schlauchs und die korrekte Funktion."
        },
        "emergency_lighting": {
          "name": "Brandschutz – Notbeleuchtung",
          "description": "Notbeleuchtung; Batterieprüfung und Mindestbetriebsdauer."
        },
        "evacuation_alarm_system": {
          "name": "Brand- und Evakuierungsalarmsystem",
          "description": "Evakuierungsalarm; Funktions- und Verständlichkeitsprüfung."
        },
        "smoke_detectors": {
          "name": "Brand - Rauchmelder",
          "description": "Rauchmelder zur frühzeitigen Branderkennung; Überprüfung auf Funktion und Verschmutzung."
        },
        "sprinkler_system": {
          "name": "Brandschutzsystem mit Sprinkleranlage",
          "description": "Automatische Feuerlöschanlage; Überprüfung von Funktion und Installation."
        },
        "escape_route_signage": {
          "name": "Beschilderung der Fluchtwege",
          "description": "Überprüfen Sie Sichtbarkeit und Aktualität."
        },
        "aed_automated_external_defibrillator": {
          "name": "Erste Hilfe – AED (Automatisierter Externer Defibrillator)",
          "description": "Überprüfung von Batterie, Elektroden und Statusanzeige."
        },
        "first_aid_kits": {
          "name": "Erste Hilfe – Erste-Hilfe-Sets",
          "description": "Überprüfung des Inhalts, der Verfallsdaten und Auffüllung der Vorräte."
        },
        "co2_carbon_monoxide_detectors": {
          "name": "Sicherheit – CO₂-/Kohlenmonoxidmelder",
          "description": "Erkennung gefährlicher CO-Konzentrationen; Überprüfung der Funktionsfähigkeit und Zuverlässigkeit der Sensoren."
        },
        "gas_detection_systems": {
          "name": "Sicherheit – Gaswarnsysteme",
          "description": "Erkennung gefährlicher Gase; Genauigkeits- und Alarmprüfung."
        },
        "evacuation_plans": {
          "name": "Sicherheit – Evakuierungspläne",
          "description": "Überprüfung der Aktualität von Evakuierungsrouten und Sammelpunkten."
        },
        "ppe_personal_protective_equipment": {
          "name": "Sicherheit – PSA (Persönliche Schutzausrüstung)",
          "description": "Prüfung auf Verschleiß, Beschädigungen und Einhaltung der Normen."
        },
        "eyewash_station": {
          "name": "Sicherheit – Augendusche",
          "description": "Spülen, auf Lecks prüfen"
        },
        "emergency_shower": {
          "name": "Sicherheit – Notdusche",
          "description": "Spülen, auf Lecks prüfen."
        }
      }
    },
    "expiry_date_display": {
      "text": {
        "click_to_reset_expiry": "Klicken Sie hier, um das Ablaufdatum auf den vorab berechneten Wert zurückzusetzen."
      }
    },
    "notified-people": {
      "text": {
        "add_email": "+ E-Mail hinzufügen",
        "add_email_title": "E-Mail-Adresse hinzufügen",
        "invalid_email": "Bitte geben Sie eine gültige E-Mail-Adresse ein"
      },
      "fields": {
        "email": "E-Mail-Adresse",
        "certification_holder": "Zertifizierungsinhaber"
      }
    },
    "renewal": {
      "text": {
        "choice_dialog_title": "Verlängerung verwalten",
        "choice_dialog_subtitle": "Wie möchten Sie die ausgewählten Elemente aktualisieren?",
        "renew_now": "Jetzt verlängern",
        "renew_now_subtitle": "Legen Sie ein neues Inspektions- und Ablaufdatum für die ausgewählten Elemente fest",
        "plan_renewal": "Verlängerung planen",
        "plan_renewal_subtitle": "Planen Sie, wann die ausgewählten Elemente verlängert werden sollen"
      }
    }
  },
  "general": {
    "text": {
      "open_in_am": "Alarmmanager",
      "app_mode": {
        "on": "An",
        "off": "Aus",
        "risk": "Risiko"
      },
      "profile": "Profil",
      "true": "WAHR",
      "false": "FALSCH",
      "move_users_failed": "Nicht alle Benutzer wurden erfolgreich verschoben",
      "move_users_success": "Alle Benutzer wurden erfolgreich verschoben",
      "move_users_title": "Benutzer verschieben",
      "move_users_explanation": "Benutzer zu einem anderen Kunden verschieben",
      "move": "Bewegen",
      "close": "Schließen",
      "deleted": "gelöscht",
      "none": "keiner",
      "all": "Alle",
      "yes": "Ja",
      "no": "NEIN",
      "invalid": "Ungültig",
      "saved": "Gerettet",
      "updated": "Aktualisiert",
      "stability": {
        "unstable": "Instabil – Verwenden Sie diese Seite nicht ohne entsprechende Schulung",
        "beta": "Beta – Sie können diese Seite frei nutzen, es könnten jedoch Probleme auftreten",
        "stable": "Stabil – Diese Seite wurde getestet und sollte wie erwartet funktionieren",
        "annotations_title": "Diese Seite enthält die folgenden Anmerkungen:"
      },
      "my_user_settings": "Meine Benutzereinstellungen",
      "never": "niemals",
      "actions": "Aktionen",
      "contact_info": "Kontaktinformationen",
      "hover_to_view": "Bewegen Sie den Mauszeiger, um es anzuzeigen",
      "export_selection": "Auswahl exportieren",
      "export_started": "Export gestartet, bitte warten...",
      "exporting": "Exportieren...",
      "export_all": "Alles exportieren",
      "not_acknowledged": "Nicht anerkannt",
      "show_persons": "%{length} Personen anzeigen",
      "copied": "In die Zwischenablage kopiert",
      "copy": "Kopieren",
      "proceed": "Fortfahren",
      "mobileWarning": "Leider ist dieses Dashboard nicht für mobile Geräte optimiert. Wir arbeiten daran, dies zu verbessern. In der Zwischenzeit empfehlen wir, zum Öffnen dieser Seite einen PC oder ein Tablet zu verwenden.",
      "appUserWarning": "Dieses Dashboard ist nur für Verwaltungsbenutzer Ihrer Organisation gedacht.\n\nSie sind derzeit mit Ihrem X-Guard Alarm App-Konto angemeldet. Als App-Benutzer können Sie das Management-Dashboard nicht anzeigen.",
      "message": "Nachricht",
      "replace": "Ersetzen",
      "append": "Anhängen",
      "skip": "Aktuellen Wert beibehalten",
      "no_template_selected": "Keine Vorlage ausgewählt",
      "no_values": "Keine Werte",
      "no_time_yet": "(Noch) keine Zeit",
      "alarm": "Alarm",
      "more_settings": "Mehr Einstellungen",
      "order": "Befehl",
      "orders": "Aufträge",
      "help": "Helfen",
      "invoices": "Rechnungen",
      "none_yet": "Noch kein %{name}, bitte erstellen Sie einen",
      "settings": "Einstellungen",
      "install_app": "Installiere die App",
      "when": "Wann?",
      "how_often": "Wie oft?",
      "gateway": "Tor",
      "button": "Taste",
      "appUserWarning_bhvk": "Dieses Dashboard ist nur für Personen gedacht, denen von einem Administrator Zugriff gewährt wurde.\n\nSie sind derzeit mit einem Konto angemeldet und haben keinen Zugriff auf dieses Dashboard. Mit diesem Konto können Sie das Dashboard nicht anzeigen.",
      "number_unknown": "Nummer unbekannt",
      "change_username_modal_title": "Willkommen im BHV-Knop.nl Dashboard",
      "current_username": "Wir haben automatisch einen Benutzernamen für Sie erstellt. Sie können ihn hier ändern",
      "continue": "weitermachen",
      "current": "Aktuell",
      "not_in": "Nicht in",
      "test": "Prüfen",
      "send": "Schicken",
      "persons": "Personen",
      "current_user": "Aktueller Benutzer",
      "this_dashboard": "Dieses Dashboard",
      "enabled": "Ermöglicht",
      "disabled": "Deaktiviert",
      "or": "oder",
      "cannot_save": "Kann nicht gespeichert werden",
      "no_changes": "Keine Änderungen",
      "theme": "Thema",
      "export_select_columns": "Wählen Sie Spalten aus",
      "toggle_all": "Alles umschalten",
      "logo": "Logo",
      "filter": "Filter",
      "location": "Standort",
      "search_google_maps": "Suche über Google Maps",
      "saving": "Sparen",
      "order_extra": "Extra bestellen",
      "solve_issues": "Lösen Sie Probleme",
      "welcome": "Willkommen",
      "gateways": "Tore",
      "order_singular": "Befehl",
      "online": "Online",
      "last_days": "Letzte %{count} Tage",
      "incorrect_phonenumber": "Falsche Telefonnummer, versuchen Sie es erneut",
      "free_trial": "Kostenlose Testphase",
      "licence_active": "Lizenz aktiv",
      "simulate_customer_admin": "Simulieren Sie die Kundenverwaltung",
      "exit_role_simulation": "Exit-Rollensimulation",
      "upload_file": "Datei hochladen (stellen Sie sicher, dass die Kodierung UTF-8 ist)",
      "emergency_button": "Notfall Knopf",
      "select_all": "Wählen Sie Alle",
      "deselect_all": "Alle abwählen",
      "order_now": "Jetzt bestellen",
      "emergency_buttons": "Notruftasten",
      "filtered": "Gefiltert",
      "go_to_management": "Gehen Sie zum Management-Dashboard",
      "go_to_bhvk": "Gehen Sie zu Beheer.BHV-Knop",
      "form": {
        "inherit": "Erben",
        "override": "Überschreiben"
      },
      "map_floors": "Boden",
      "device": "Gerät",
      "search_location": "Standort suchen",
      "availability": "Verfügbarkeit",
      "from": "Aus",
      "until": "Bis",
      "optional": "Optional",
      "general": "Allgemein",
      "invalid_time": "Muss eine gültige Zeit sein",
      "time_end_before_start": "Die Endzeit muss nach der Startzeit liegen.",
      "timestamp": "Zeitstempel",
      "history": "Geschichte",
      "seconds": "Sekunden",
      "person": "Person |||| Personen",
      "customer_not_found": "Kein Kunde mit der angegebenen ID gefunden",
      "present": "Gegenwärtig",
      "overwrite": "Überschreiben",
      "add": "Hinzufügen",
      "remove": "Entfernen",
      "buttons_or_persons": "Knöpfe oder Personen",
      "add_from_presets": "Aus Voreinstellungen hinzufügen",
      "edit": "Bearbeiten",
      "loading": "Laden",
      "loading_secondary": "Bitte warten",
      "items": "Artikel",
      "confirm": "Bestätigen",
      "days": "Tage",
      "time_granularity_types": {
        "day": "1 Tag |||| %{smart_count} Tage",
        "week": "1 Woche |||| %{smart_count} Wochen",
        "month": "1 Monat |||| %{smart_count} Monate",
        "quarter": "1 Quartal |||| %{smart_count} Quartale",
        "year": "1 Jahr |||| %{smart_count} Jahre"
      },
      "add_email": "+ E-Mail hinzufügen",
      "add_email_title": "E-Mail-Adresse hinzufügen",
      "invalid_email": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      "add_custom_category": "Benutzerdefinierte Kategorie hinzufügen",
      "add_custom_category_subtitle": "Fügen Sie eine benutzerdefinierte Kategorie hinzu und konfigurieren Sie alle Einstellungen manuell",
      "add_from_presets_subtitle": "Wählen Sie eine oder mehrere vorkonfigurierte Kategorien aus",
      "clear": "Leeren"
    },
    "fields": {
      "createdAt": "Hergestellt in",
      "updatedAt": "Aktualisiert am",
      "position": {
        "address": {
          "countrycode": "Landesvorwahl",
          "state": "Zustand",
          "city": "Stadt",
          "streetName": "Straßenname",
          "streetNumber": "Hausnummer",
          "floor": "Boden",
          "formattedAddress": "Formatierte Adresse gespeichert",
          "name": "Adresse"
        },
        "latitude": "Breite",
        "longitude": "Längengrad",
        "coordinates": "Koordinaten",
        "name": "Position",
        "properties": {
          "dateTime": "Positionszeitstempel"
        }
      },
      "name": "Name",
      "description": "Beschreibung",
      "person_or_object": "Person oder Objekt",
      "madeBy": "Hergestellt von",
      "number": "Nummer",
      "registration_profile": "Registrierungsprofil",
      "email": "E-Mail-Adresse"
    },
    "errors": {
      "username_too_short": "Der Benutzername sollte mindestens drei Zeichen lang sein"
    }
  },
  "pages": {
    "live_map": {
      "text": {
        "no_assets_in_customer": "Keine Personen oder Gegenstände gefunden",
        "position_is": "Position ist",
        "indoors": "drinnen",
        "outdoors": "draußen",
        "at": " bei",
        "accuracy": "Die Genauigkeit beträgt %{accuracy} Meter",
        "last_position": "Letzte Position war %{time}",
        "person_available": "Diese Person ist %{available} verfügbar",
        "not": "nicht",
        "app_mode": "App-Modus ist"
      }
    },
    "userReceiverInitialisation": {
      "title": "Wie möchten Sie Alarme erhalten?"
    }
  },
  "menu": {
    "items": {
      "live": "Live",
      "map": "Karte",
      "my_organisation": "Meine Organisation",
      "alarms": "Alarm",
      "create_alarm": "Alarm erstellen",
      "access": "Zugang",
      "root_admins": "Root-Administratoren",
      "problematic_alarms": "Problematische Alarme",
      "alarm_app": "X-Guard Alarm-App",
      "groups": "Gruppen",
      "qr_codes": "QR-Codes",
      "people_assets": "Menschen und Vermögenswerte",
      "assets": "Vermögenswerte",
      "tags": "Stichworte",
      "flic": "Flic",
      "alarm_tasks": "Alarmaufgaben",
      "resources": "Ressourcen",
      "alarm_handling": "Alarmbearbeitung",
      "reports": "Berichte",
      "manage": "Verwalten",
      "users": "Admins",
      "management_users": "Benutzer",
      "dashboard": "Armaturenbrett",
      "maps": "Karten",
      "response": "Antwort",
      "app-defaults": "App-Konfigurationsvorgaben",
      "certifications": "Zertifizierungen",
      "security_inventory": "Sicherheitsinventar",
      "customer_access_request": "Kundenzugriff anfordern",
      "customer_access_review": "Kundenzugriffsanfragen prüfen"
    },
    "text": {
      "brought_by": "Präsentiert von"
    }
  },
  "home": {
    "text": {
      "title": "Willkommen beim X-Guard Management-Dashboard",
      "description": "Mit diesem Dashboard können Sie Ihre aktuelle X-Guard-Umgebung anzeigen. Leider ist es noch nicht möglich, die angezeigten Ressourcen zu bearbeiten. Bearbeitungs- und Erstellungsmöglichkeiten werden später hinzugefügt.",
      "block_one": "### Willkommen beim X-Guard Management-Dashboard\n\nMit diesem Dashboard können Sie Ihre aktuelle X-Guard-Umgebung verwalten und anzeigen.",
      "block_two": "#### Update 1.21\nDie Seite „Verfügbarkeit“ steht Ihnen jetzt zur Überwachung Ihrer Zonen zur Verfügung. Sehen Sie sofort die Anzahl der Personen, die in Ihren Zonen verfügbar sind, um auf Alarme zu reagieren.\n\nDarüber hinaus können Sie wählen, ob Sie E-Mail-Warnungen erhalten möchten, wenn der festgelegte Schwellenwert nicht erreicht wird.\n\n#### Update 1.20\nAb dieser Version ist es möglich, Grundrisse hinzuzufügen. Karten sind auf allen Seiten mit einer Karte in diesem Dashboard und auf BHV-Knop.nl-Kioskbildschirmen in Ihrer Organisation sichtbar. Grundrisse werden auch von Disponenten verwendet, um sich innerhalb eines Gebäudes genauer zu lokalisieren.\n\nDarüber hinaus wurden jetzt unter der Überschrift „Live“ verschiedene Berichte hinzugefügt, mit denen Sie den aktuellen Status Ihrer Organisation sofort überwachen können.\n\n#### Update 1.19\nDiese Version war ein größeres Stabilitätsupdate.\n\n#### Update 1.18\nEs ist jetzt möglich, Berichte direkt von diesem Dashboard aus zu verwalten. Passen Sie an, ob Berichte gesendet werden und an wen.\n\n#### Update 1.17\n\nAb Version 1.17 können Sie nun auf die Zonenkonfigurationsseite zugreifen. Diese Seite gibt Ihnen Einblick, wie bestimmte Zonen im X-Guard-System definiert sind.\n\nSie können Zonen bearbeiten, hinzufügen und löschen. Das Hinzufügen einer erweiterten Konfiguration zu einer Zone wird jedoch weiterhin vom X-Guard-Supportteam durchgeführt. Aus Sicherheitsgründen ist es nicht möglich, eine Zone zu löschen, der eine erweiterte Konfiguration zugeordnet ist.\n\nSie wissen nicht, wo Sie anfangen sollen? Bitte wenden Sie sich für eine kurze Erklärung an Ihren X-Guard-Account-Manager.\n\n#### Update 1.16\n\nEs ist jetzt möglich, App-Benutzer direkt vom Dashboard aus **hinzuzufügen, zu entfernen und zu bearbeiten**. Sie können auch **Gruppen verwalten** und **Benutzer verwalten**.\n\nApp-Benutzer sind Benutzer, die die X-Guard-Alarm-App verwenden können. Sie können das Management-Dashboard und den Alarm-Manager nicht verwenden.\n\nBenutzer haben Zugriff auf das Management-Dashboard und den Alarm-Manager und können Verwaltungsaufgaben ausführen.",
      "block_three": "#### Rückmeldung\n\nIst Ihnen in diesem Dashboard etwas aufgefallen, das nicht ganz stimmt? Oder haben Sie eine neue Funktionsanfrage?\n\n**In der unteren rechten Ecke aller Seiten** befindet sich ein praktischer **Feedback-Button**. Klicken Sie auf diese Schaltfläche, um Ihr Feedback direkt an das X-Guard-Entwicklungsteam zu senden."
    }
  },
  "ra": {
    "message": {
      "clear_array_input": "Sind Sie sicher, dass Sie die gesamte Liste löschen möchten?"
    },
    "input": {
      "image": {
        "remove_current": "Aktuelle entfernen"
      }
    },
    "action": {
      "preview": "Vorschau",
      "publish": "Veröffentlichen",
      "manage_renewal": "Verlängerung verwalten"
    },
    "notification": {
      "name_too_long": "Name zu lang"
    }
  },
  "qr-templates": {
    "text": {
      "page_info": "Mit einem QR-Code registrieren Sie sich direkt über die X-Guard Alarm-App in Ihrer Organisation.\n\nTeilen Sie die QR-Codes mit Personen, die sich in der App anmelden müssen."
    }
  },
  " resources": {
    "report-triggers": {
      "text": {
        "config_types": {
          "unhealthyBeacons": "Ungesunde Beacons"
        }
      }
    }
  },
  "resource": {
    "customers": {
      "fields": {
        "hasKioskConfig": "Hat eine Kiosk-Konfiguration"
      }
    },
    "buttons": {
      "automove_subtitle": "Wir können diese Schaltfläche automatisch an die neue Adresse verschieben. Möchten Sie diese Schaltfläche verschieben?",
      "automove_no": "Nein, aktuelle Position beibehalten",
      "automove_yes": "Ja, automatischer Umzug an neue Adresse"
    }
  },
  "homepage": {
    "text": {
      "welcome_text2": "auf Ihrem bhv-knop.nl-Dashboard",
      "welcome_subtext": "Über dieses Dashboard können Sie unser gesamtes System sofort testen.\nWenn Sie über dieses Dashboard einen Testalarm erstellen, wird Ihnen dieser telefonisch oder über unsere App mitgeteilt.\nIn der Vollversion des Systems können Notruftaster mit den eigenen Gebäuden und Standorten verknüpft werden.",
      "actual_status": "Aktueller Status Ihres Systems",
      "show_gateways": "Gateways anzeigen",
      "continue_setting_up": "Fahren Sie mit der Einrichtung Ihres Kontos fort",
      "continue_setting_up_subtext": "Bevor Sie einen Alarm auslösen können, müssen Sie eine Telefonnummer angeben. Dies ist notwendig, um Sie im Alarmfall anzurufen. Es ist möglich, über unsere App einen Alarm zu empfangen."
    }
  },
  "ra-audit-log": {
    "inline_event": {
      "read": "Lesen"
    }
  },
  "notifications": {
    "customer_access_request_browser": {
      "title": "Kundenzugriffsanfrage",
      "body_fallback": "Ein neuer Kundenzugriffsantrag ist in Bearbeitung.",
      "customer_id_prefix": "Kunde ",
      "user_id_prefix": "Benutzer"
    }
  },
  "clientConfig": {
    "menu": {
      "manager": "ClientConfig Manager",
      "groups": "ClientConfig-Gruppen"
    },
    "buttons": {
      "openManager": "ClientConfig Manager öffnen"
    },
    "manager": {
      "title": "ClientConfig Manager",
      "customer": "Kunde",
      "group": "Gruppe",
      "device": "Gerät",
      "assignedGroups": "ClientConfig-Gruppen",
      "selectGroups": "Gruppen auswählen",
      "changedKeys": "Geänderte Tasten im Vergleich zu den Standardeinstellungen",
      "baseline": {
        "settings": "Grundeinstellungen",
        "selectLabel": "Vergleich mit dem Standardwert",
        "mode": {
          "allCustomers": "Alle Kunden (weltweit)",
          "thisCustomer": "Dieser Kunde",
          "thisGroup": "Diese Gruppe",
          "thisDevice": "Dieses Gerät"
        },
        "customerUnavailable": "Der Kunde für diesen Artikel konnte nicht ermittelt werden.",
        "groupUnavailable": "Die Gruppenbaseline ist nur während der Bearbeitung einer Gruppe verfügbar.",
        "deviceUnavailable": "Die Geräte-Baseline ist nur während der Bearbeitung eines Geräts verfügbar."
      },
      "resetInlineKey": "Einstellungen zurücksetzen",
      "restoreInlineKey": "Einstellungen wiederherstellen",
      "unsavedChanges": {
        "title": "Nicht gespeicherte Änderungen",
        "message": "Sie haben ungespeicherte Gruppen- oder Schlüsseländerungen. Speichern Sie diese, bevor Sie diese Seite verlassen.",
        "save": "Speichern",
        "stay": "Bleiben Sie auf Seite"
      }
    },
    "groups": {
      "form": {
        "groups": "ClientConfig-Gruppen",
        "keys": "ClientConfig-Schlüssel",
        "key": "Schlüssel",
        "editable": "Bearbeitbar",
        "editableBy": "Bearbeitbar von",
        "customerSpecific": "Kundenspezifische Gruppe"
      },
      "preview": {
        "title": "ClientConfig-Vorschau",
        "noChanges": "Keine Änderungen gegenüber der Standardeinstellung.",
        "inlineKey": "Inline-Taste (keine Gruppenquelle)",
        "description": "Sehen Sie, wie das Hinzufügen oder Entfernen von Gruppen und Schlüsseln die resultierende Client-Konfiguration beeinflusst."
      },
      "list": {
        "showGlobalGroups": "Globale ClientConfig-Gruppen anzeigen"
      }
    },
    "preview": {
      "chip": {
        "new": "Neu",
        "changed": "Geändert",
        "removedByGroup": "Durch Gruppenänderung entfernt",
        "editedByOtherGroup": "Bearbeitet von einer anderen Gruppe",
        "removedInlineKey": "Einstellung entfernt"
      }
    }
  }
} as const

export default language